import React, { useEffect, useState, useMemo, useRef, useCallback } from "react"
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap"
import api from "API/Api"
import SweetAlert from "react-bootstrap-sweetalert"
import PageLoader from "./../../assets/loading/pageLoad1.gif"
import { usePermissions } from "API/PermissionContext"

const arr = r => { const d = r?.data?.data; return Array.isArray(d) ? d : d?.data || [] }
const fmt = v => v === undefined || v === null || v === "" ? "" : v

const CCPurchases = () => {
  const { canAdd, canEdit, canDelete, MODULE } = usePermissions()
  const MID = MODULE.CC_PURCHASES

  // Ã¢â€â‚¬Ã¢â€â‚¬ tab Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬
  const [activeTab, setActiveTab] = useState("active")

  // Ã¢â€â‚¬Ã¢â€â‚¬ list state Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬
  const [purchases, setPurchases] = useState([])
  const [deleted, setDeleted] = useState([])
  const [pageLoad, setPageLoad] = useState(true)
  const [page, setPage] = useState(1)
  const [totalPages, setTotalPages] = useState(1)
  const [dPage, setDPage] = useState(1)
  const [dTotalPages, setDTotalPages] = useState(1)
  const [search, setSearch] = useState("")
  const [dSearch, setDSearch] = useState("")
  const [dFilterDate, setDFilterDate] = useState("")
  const [dFilterDateTo, setDFilterDateTo] = useState("")
  const [dShowFilter, setDShowFilter] = useState(false)
  const [selected, setSelected] = useState([])

  // Ã¢â€â‚¬Ã¢â€â‚¬ filter Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬
  const [showFilter, setShowFilter] = useState(false)
  const [filterDate, setFilterDate] = useState("")
  const [filterDateTo, setFilterDateTo] = useState("")
  const [filterShift, setFilterShift] = useState("")
  const [filterMilk, setFilterMilk] = useState("")

  // Ã¢â€â‚¬Ã¢â€â‚¬ delete alert Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬
  const [confirmDel, setConfirmDel] = useState(false)
  const [deleteId, setDeleteId] = useState(null)
  const [successDlg, setSuccessDlg] = useState(false)
  const [bulkConfirm, setBulkConfirm] = useState(false)

  // Ã¢â€â‚¬Ã¢â€â‚¬ companies / cascade (shared) Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬
  const [companies, setCompanies] = useState([])

  // â”€â”€â”€ Bulk Purchase Update modal â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  const [cuOpen, setCuOpen] = useState(false)
  const [cuCompany, setCuCompany] = useState("")
  const [cuPlant, setCuPlant] = useState("")
  const [cuCC, setCuCC] = useState("")
  const [cuRoute, setCuRoute] = useState("")
  const [cuVendor, setCuVendor] = useState("")
  const [cuPlants, setCuPlants] = useState([])
  const [cuCCs, setCuCCs] = useState([])
  const [cuRoutes, setCuRoutes] = useState([])
  const [cuVendors, setCuVendors] = useState([])
  const [cuDisplay, setCuDisplay] = useState("single")
  const [cuDate, setCuDate] = useState("")
  const [cuShift, setCuShift] = useState("")
  const [cuPeriodFrom, setCuPeriodFrom] = useState("")
  const [cuPeriodTo, setCuPeriodTo] = useState("")
  const [cuMilkType, setCuMilkType] = useState("0")
  const [cuEntryMode, setCuEntryMode] = useState("SNF")
  const [cuUseCustomRate, setCuUseCustomRate] = useState("No")
  const [cuRateCharts, setCuRateCharts] = useState([])
  const [cuRateChartId, setCuRateChartId] = useState("")
  const [cuApplyInc, setCuApplyInc] = useState("No")
  const [cuIncentiveCharts, setCuIncentiveCharts] = useState([])
  const [cuIncentiveChartId, setCuIncentiveChartId] = useState("")
  const [cuFlatInc, setCuFlatInc] = useState("")
  const [cuPreviewRows, setCuPreviewRows] = useState([])
  const [cuOrigRows, setCuOrigRows] = useState([])
  const [cuTotal, setCuTotal] = useState(0)
  const [cuLoading, setCuLoading] = useState(false)
  const [cuSaving, setCuSaving] = useState(false)
  const [cuResult, setCuResult] = useState(null)
  // Manipulate Values
  const [cuOvAction, setCuOvAction] = useState("increase")
  const [cuOvField, setCuOvField] = useState("qty")
  const [cuOvBy, setCuOvBy] = useState("")
  const [cuOvCondField, setCuOvCondField] = useState("qty")
  const [cuOvCondMin, setCuOvCondMin] = useState("")
  const [cuOvCondMax, setCuOvCondMax] = useState("")

  // â”€â”€â”€ Bulk Purchase Session Update modal â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  const [bsuOpen, setBsuOpen] = useState(false)
  const [bsuCompany, setBsuCompany] = useState("")
  const [bsuPlant, setBsuPlant] = useState("")
  const [bsuCC, setBsuCC] = useState("")
  const [bsuDate, setBsuDate] = useState("")
  const [bsuShift, setBsuShift] = useState("")
  const [bsuPlants, setBsuPlants] = useState([])
  const [bsuCCs, setBsuCCs] = useState([])
  const [bsuRows, setBsuRows] = useState([])
  const [bsuCurrentRow, setBsuCurrentRow] = useState(1)   // 1-indexed
  const [bsuLoading, setBsuLoading] = useState(false)
  const [bsuSaving, setBsuSaving] = useState(false)
  const [bsuAlert, setBsuAlert] = useState(null)  // {type:'info'|'error', msg}
  const [bsuPreviewDone, setBsuPreviewDone] = useState(false)
  const [bsuResult, setBsuResult] = useState(null)
  const [ddOpen, setDdOpen] = useState(false)
  const [ddPos, setDdPos] = useState({ top: 0, left: 0 })
  const ddBtnRef = useRef(null)

  // --- Bulk SMS State ---
  const [csOpen, setCsOpen] = useState(false)
  const [csPlant, setCsPlant] = useState("")
  const [csCC, setCsCC] = useState("")
  const [csRoute, setCsRoute] = useState("")
  const [csPlants, setCsPlants] = useState([])
  const [csCCs, setCsCCs] = useState([])
  const [csRoutes, setCsRoutes] = useState([])
  const [csDate, setCsDate] = useState("")
  const [csShift, setCsShift] = useState("")
  const [csVendorType, setCsVendorType] = useState("both")
  const [csIgnore, setCsIgnore] = useState(false)
  const [csPreviewRows, setCsPreviewRows] = useState([])
  const [csPreviewMeta, setCsPreviewMeta] = useState(null)
  const [csResult, setCsResult] = useState(null)
  const [csChecked, setCsChecked] = useState({})
  const [csLoading, setCsLoading] = useState(false)
  const [csSending, setCsSending] = useState(false)

  // â”€â”€â”€ More Actions Modals State â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  // Excel Import Single Shift
  const [exSOpen, setExSOpen] = useState(false)
  const [exSPlant, setExSPlant] = useState("")
  const [exSCC, setExSCC] = useState("")
  const [exSDate, setExSDate] = useState("")
  const [exSShift, setExSShift] = useState("0")
  const [exSPlants, setExSPlants] = useState([])
  const [exSCCs, setExSCCs] = useState([])
  const [exSFile, setExSFile] = useState(null)
  const [exSPreview, setExSPreview] = useState([])
  const [exSLoading, setExSLoading] = useState(false)
  const [exSSaving, setExSSaving] = useState(false)
  const [exSResult, setExSResult] = useState(null)

  // Excel Import Multi Shift
  const [exMOpen, setExMOpen] = useState(false)
  const [exMPlant, setExMPlant] = useState("")
  const [exMCC, setExMCC] = useState("")
  const [exMPlants, setExMPlants] = useState([])
  const [exMCCs, setExMCCs] = useState([])
  const [exMFile, setExMFile] = useState(null)
  const [exMPreview, setExMPreview] = useState([])
  const [exMLoading, setExMLoading] = useState(false)
  const [exMSaving, setExMSaving] = useState(false)
  const [exMResult, setExMResult] = useState(null)

  // FTP Import
  const [ftpIOpen, setFtpIOpen] = useState(false)
  const [ftpIPlant, setFtpIPlant] = useState("")
  const [ftpICC, setFtpICC] = useState("")
  const [ftpIDate, setFtpIDate] = useState("")
  const [ftpIShift, setFtpIShift] = useState("0")
  const [ftpIPlants, setFtpIPlants] = useState([])
  const [ftpICCs, setFtpICCs] = useState([])
  const [ftpILoading, setFtpILoading] = useState(false)
  const [ftpIResult, setFtpIResult] = useState(null)

  // FTP Export
  const [ftpEOpen, setFtpEOpen] = useState(false)
  const [ftpEPlant, setFtpEPlant] = useState("")
  const [ftpECC, setFtpECC] = useState("")
  const [ftpEDate, setFtpEDate] = useState("")
  const [ftpEPlants, setFtpEPlants] = useState([])
  const [ftpECCs, setFtpECCs] = useState([])
  const [ftpELoading, setFtpELoading] = useState(false)
  const [ftpEResult, setFtpEResult] = useState(null)

  // CSV Download
  const [csvOpen, setCsvOpen] = useState(false)
  const [csvPlant, setCsvPlant] = useState("")
  const [csvCC, setCsvCC] = useState("")
  const [csvRoute, setCsvRoute] = useState("")
  const [csvDate, setCsvDate] = useState("")
  const [csvShift, setCsvShift] = useState("")
  const [csvPlants, setCsvPlants] = useState([])
  const [csvCCs, setCsvCCs] = useState([])
  const [csvRoutes, setCsvRoutes] = useState([])
  const [csvLoading, setCsvLoading] = useState(false)

  // Incentive Update
  const [incOpen, setIncOpen] = useState(false)
  const [incPlant, setIncPlant] = useState("")
  const [incCC, setIncCC] = useState("")
  const [incDate, setIncDate] = useState("")
  const [incShift, setIncShift] = useState("")
  const [incAmount, setIncAmount] = useState("")
  const [incPlants, setIncPlants] = useState([])
  const [incCCs, setIncCCs] = useState([])
  const [incLoading, setIncLoading] = useState(false)
  const [incResult, setIncResult] = useState(null)

  // Parameter Color Details
  const [colorOpen, setColorOpen] = useState(false)

  // --- Procurement Comparison Summary State ---
  const [cmpOpen, setCmpOpen] = useState(false)
  const [cmpPlant, setCmpPlant] = useState("")
  const [cmpCC, setCmpCC] = useState("")
  const [cmpRoute, setCmpRoute] = useState("")
  const [cmpCenter, setCmpCenter] = useState("")
  const [cmpPlants, setCmpPlants] = useState([])
  const [cmpCCs, setCmpCCs] = useState([])
  const [cmpRoutes, setCmpRoutes] = useState([])
  const [cmpCenters, setCmpCenters] = useState([])
  const [cmpFrom, setCmpFrom] = useState("")
  const [cmpTo, setCmpTo] = useState("")
  const [cmpDisplay, setCmpDisplay] = useState("all")
  const [cmpBasis, setCmpBasis] = useState("qty_only")
  const [cmpParams, setCmpParams] = useState([])
  const [cmpParamOpen, setCmpParamOpen] = useState(false)
  const [cmpLoading, setCmpLoading] = useState(false)
  const [cmpResult, setCmpResult] = useState(null)

  // â”€â”€â”€ Bulk SMS handlers â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  const resetCs = () => {
    setCsPlant(""); setCsCC(""); setCsRoute(""); setCsPlants([]); setCsCCs([]); setCsRoutes([])
    setCsDate(""); setCsShift(""); setCsVendorType("both"); setCsIgnore(false)
    setCsPreviewRows([]); setCsPreviewMeta(null); setCsResult(null); setCsChecked({})
  }

  const openCsModal = () => {
    resetCs()
    api.get("companies").then(r => {
      const list = arr(r); setCompanies(list)
      if (list.length <= 1) api.get("plants").then(r2 => setCsPlants(arr(r2))).catch(() => { })
    }).catch(() => { api.get("plants").then(r2 => setCsPlants(arr(r2))).catch(() => { }) })
    setCsOpen(true)
  }

  const onCsCompanyChange = v => {
    setCsPlant(""); setCsCC(""); setCsRoute(""); setCsPlants([]); setCsCCs([]); setCsRoutes([])
    setCsPreviewRows([]); setCsPreviewMeta(null); setCsResult(null)
    if (v) api.get("plants-by-company/" + v).then(r => setCsPlants(arr(r))).catch(() => { })
    else api.get("plants").then(r => setCsPlants(arr(r))).catch(() => { })
  }
  const onCsPlant = async v => {
    setCsPlant(v); setCsCC(""); setCsRoute(""); setCsCCs([]); setCsRoutes([])
    setCsPreviewRows([]); setCsPreviewMeta(null)
    if (v) try { setCsCCs(arr(await api.get("chillings-by-plant/" + v))) } catch (e) { }
  }
  const onCsCC = async v => {
    setCsCC(v); setCsRoute(""); setCsRoutes([])
    setCsPreviewRows([]); setCsPreviewMeta(null)
    if (v) try { setCsRoutes(arr(await api.get("route-cc/" + v))) } catch (e) { }
  }
  const onCsRoute = v => { setCsRoute(v); setCsPreviewRows([]); setCsPreviewMeta(null) }

  const handleCsPreview = async () => {
    if (!csCC) return alert("Chilling Center is required.")
    if (!csDate) return alert("Date is required.")
    if (csShift === "") return alert("Shift is required.")
    setCsLoading(true); setCsPreviewRows([]); setCsPreviewMeta(null); setCsResult(null); setCsChecked({})
    try {
      const r = await api.post("cc-purchase-sms-preview", {
        chillingCenter: csCC, route: csRoute || "", date: csDate, shift: csShift,
        vendorType: csVendorType, ignoreAlreadySent: csIgnore
      })
      const rows = r.data.data || []
      setCsPreviewRows(rows)
      setCsPreviewMeta({ total: r.data.total, willSend: r.data.willSend, noMobile: r.data.noMobile, alreadySent: r.data.alreadySent })
      // Auto-check vendors that willSend
      const chk = {}
      rows.forEach(row => { if (row.willSend) chk[row.type + "_" + row.vendorId] = true })
      setCsChecked(chk)
    } catch (e) { alert(e.response?.data?.data || "Preview failed.") }
    setCsLoading(false)
  }

  const handleCsSend = async () => {
    const selectedKeys = Object.keys(csChecked).filter(k => csChecked[k])
    if (selectedKeys.length === 0) return alert("No vendors selected.")
    if (!window.confirm("Send SMS to " + selectedKeys.length + " vendor(s)? This cannot be undone.")) return
    setCsSending(true); setCsResult(null)
    try {
      const r = await api.post("cc-purchase-sms-send", {
        chillingCenter: csCC, route: csRoute || "", date: csDate, shift: csShift,
        vendorType: csVendorType, ignoreAlreadySent: csIgnore,
        selectedVendors: selectedKeys
      })
      setCsResult({ success: r.data.success, message: r.data.data, sent: r.data.sent, failed: r.data.failed, errors: r.data.errors || [] })
    } catch (e) { setCsResult({ success: false, message: e.response?.data?.data || "Send failed.", sent: 0, failed: 0, errors: [] }) }
    setCsSending(false)
  }

  // â”€â”€â”€ Bulk Purchase Entry modal â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  const [bpOpen, setBpOpen] = useState(false)
  const [bpCompany, setBpCompany] = useState("")
  const [bpPlant, setBpPlant] = useState("")
  const [bpCC, setBpCC] = useState("")
  const [bpDate, setBpDate] = useState("")
  const [bpShift, setBpShift] = useState("0")
  const [bpMode, setBpMode] = useState("SNF")
  const [bpPlants, setBpPlants] = useState([])
  const [bpCCs, setBpCCs] = useState([])
  const [bpShowTable, setBpShowTable] = useState(false)   // table only after "Add New"
  const [bpSaving, setBpSaving] = useState(false)
  const [bpCompanySettings, setBpCompanySettings] = useState(null) // company_settings for auto-compute

  const defaultBpRow = () => ({
    routeNo: "", routeName: "", routeId: null, routeLookupState: "",   // "ok"|"err"|""
    vendorNo: "", vendorName: "", vendorId: null, vendorLookupState: "", // "ok"|"err"|""
    milkType: "3", qty: "", purchaseFat: "", purchaseSnf: "", purchaseClr: "",
  })
  const [bpRows, setBpRows] = useState([defaultBpRow()])

  const resetBp = () => {
    setBpCompany(""); setBpPlant(""); setBpCC(""); setBpDate(""); setBpShift("0"); setBpMode("SNF")
    setBpPlants([]); setBpCCs([]); setBpRows([defaultBpRow()]); setBpShowTable(false)
  }

  const openBp = () => {
    resetBp()
    api.get("companies").then(r => {
      const list = arr(r); setCompanies(list)
      if (list.length <= 1) api.get("plants").then(r2 => setBpPlants(arr(r2))).catch(() => { })
    }).catch(() => { api.get("plants").then(r2 => setBpPlants(arr(r2))).catch(() => { }) })
    setBpOpen(true)
  }

  const onBpCompany = async v => {
    setBpCompany(v); setBpPlant(""); setBpCC(""); setBpPlants([]); setBpCCs([])
    if (v) { try { setBpPlants(arr(await api.get("plants-by-company/" + v))) } catch (e) { } }
    else { try { setBpPlants(arr(await api.get("plants"))) } catch (e) { } }
  }
  const onBpPlant = async v => {
    setBpPlant(v); setBpCC(""); setBpCCs([]); setBpShowTable(false)
    if (v) { try { setBpCCs(arr(await api.get("chillings-by-plant/" + v))) } catch (e) { } }
  }
  const onBpCC = async v => {
    setBpCC(v); setBpShowTable(false); setBpCompanySettings(null)
    if (v) {
      // Fetch company settings via CC -> Plant -> Company chain
      try {
        const ccList = bpCCs.length ? bpCCs : arr(await api.get("chillings-by-plant/" + bpPlant))
        const cc = ccList.find(c => String(c.id) === String(v))
        if (cc && cc.plant_id) {
          const plant = bpPlants.find(p => String(p.id) === String(cc.plant_id)) || (bpPlant ? { id: bpPlant, company_id: bpCompany } : null)
          const companyId = plant?.company_id || bpCompany || (companies.length === 1 ? companies[0].id : "")
          if (companyId) {
            const sr = await api.get("settings-by-company/" + companyId)
            setBpCompanySettings(sr.data?.data || sr.data || null)
          }
        }
      } catch (e) { /* settings fetch failed, will use defaults */ }
    }
  }

  // â”€â”€â”€ Bulk Purchase Update handlers â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  const resetCu = () => {
    setCuCompany(""); setCuPlant(""); setCuCC(""); setCuRoute(""); setCuVendor("")
    setCuPlants([]); setCuCCs([]); setCuRoutes([]); setCuVendors([])
    setCuDisplay("single"); setCuDate(""); setCuShift(""); setCuPeriodFrom(""); setCuPeriodTo("")
    setCuMilkType("0"); setCuEntryMode("SNF"); setCuUseCustomRate("No")
    setCuRateCharts([]); setCuRateChartId("")
    setCuApplyInc("No"); setCuIncentiveChartId(""); setCuFlatInc("")
    setCuPreviewRows([]); setCuOrigRows([]); setCuTotal(0); setCuResult(null)
    setCuOvAction("increase"); setCuOvField("qty"); setCuOvBy("")
    setCuOvCondField("qty"); setCuOvCondMin(""); setCuOvCondMax("")
  }

  const openCu = () => {
    resetCu()
    api.get("active-incentive-charts").then(r => setCuIncentiveCharts(arr(r))).catch(() => {})
    api.get("companies").then(r => {
      const list = arr(r); setCompanies(list)
      if (list.length <= 1) api.get("plants").then(r2 => setCuPlants(arr(r2))).catch(() => { })
    }).catch(() => { api.get("plants").then(r2 => setCuPlants(arr(r2))).catch(() => { }) })
    setCuOpen(true)
  }

  const cuTypeMap = { "0": 3, "1": 1, "2": 2 }
  const onCuMilkType = async v => {
    setCuMilkType(v); setCuRateChartId(""); setCuPreviewRows([]); setCuResult(null)
    if (cuUseCustomRate === "Yes") {
      try { setCuRateCharts(arr(await api.get("rate-chart-type/" + (cuTypeMap[v] || 3)))) } catch(e) {}
    }
  }
  const onCuUseCustomRate = async v => {
    setCuUseCustomRate(v); setCuRateChartId(""); setCuPreviewRows([]); setCuResult(null)
    if (v === "Yes") {
      try { setCuRateCharts(arr(await api.get("rate-chart-type/" + (cuTypeMap[cuMilkType] || 3)))) } catch(e) {}
    } else { setCuRateCharts([]) }
  }
  const cuChartLabel = cuMilkType === "1" ? "Custom Cow Milk Chart"
                     : cuMilkType === "2" ? "Custom Buffalo Milk Chart"
                     : "Custom Common Milk Chart"

  const onCuCompany = async v => {
    setCuCompany(v); setCuPlant(""); setCuCC(""); setCuRoute(""); setCuVendor("")
    setCuPlants([]); setCuCCs([]); setCuRoutes([]); setCuVendors([])
    setCuPreviewRows([]); setCuResult(null)
    try {
      setCuPlants(arr(await (v ? api.get("plants-by-company/" + v) : api.get("plants"))))
    } catch (e) { }
  }
  const onCuPlant = async v => {
    setCuPlant(v); setCuCC(""); setCuRoute(""); setCuVendor("")
    setCuCCs([]); setCuRoutes([]); setCuVendors([])
    setCuPreviewRows([]); setCuResult(null)
    if (v) try { setCuCCs(arr(await api.get("chillings-by-plant/" + v))) } catch (e) { }
  }
  const onCuCC = async v => {
    setCuCC(v); setCuRoute(""); setCuVendor(""); setCuRoutes([]); setCuVendors([])
    setCuPreviewRows([]); setCuResult(null)
    if (v) try { setCuRoutes(arr(await api.get("route-cc/" + v))) } catch (e) { }
  }
  const onCuRoute = async v => {
    setCuRoute(v); setCuVendor(""); setCuVendors([])
    setCuPreviewRows([]); setCuResult(null)
    if (v) {
      try {
        // load vendors for this CC + Route
        const res = await api.get("vendors?per_page=500")
        const all = arr(res)
        const filtered = all.filter(vv => String(vv.chillingCenter) === String(cuCC) && String(vv.route) === String(v))
        setCuVendors(filtered.length > 0 ? filtered : all.filter(vv => String(vv.chillingCenter) === String(cuCC)))
      } catch (e) { }
    }
  }

  const cuBuildPayload = () => ({
    chillingCenter: cuCC,
    route: cuRoute || "",
    vendor: cuVendor || "",
    displayMode: cuDisplay,
    date: cuDate,
    shift: cuShift,
    periodFrom: cuPeriodFrom,
    periodTo: cuPeriodTo,
    milkType: cuMilkType,
    entryMode: cuEntryMode,
    useCustomRate: cuUseCustomRate,
    customRateChartId: cuRateChartId || "",
    applyIncentive: cuApplyInc,
    incentiveChartId: cuIncentiveChartId || "",
    flatIncentivePerLtr: cuFlatInc || "0",
  })

  const handleCuPreview = async () => {
    if (!cuCC) return alert("Chilling Center is required.")
    if (cuDisplay === "single" && !cuDate) return alert("Date is required.")
    if (cuDisplay === "single" && cuShift === "") return alert("Shift is required.")
    if (cuDisplay === "period" && (!cuPeriodFrom || !cuPeriodTo)) return alert("Period From and To are required.")
    if (cuUseCustomRate === "Yes" && !cuRateChartId) return alert("Please select a Custom Rate Chart.")
    if (cuApplyInc === "chart" && !cuIncentiveChartId) return alert("Please select a Custom Incentive Chart.")
    if (cuApplyInc === "flat" && !(parseFloat(cuFlatInc) > 0)) return alert("Flat Incentive per Liter must be > 0.")
    setCuLoading(true); setCuPreviewRows([]); setCuOrigRows([]); setCuTotal(0); setCuResult(null)
    try {
      const r = await api.post("cc-purchase-update-preview", cuBuildPayload())
      if (r.data.success) {
        const rows = r.data.data || []
        setCuPreviewRows(rows); setCuOrigRows(rows.map(x => ({ ...x }))); setCuTotal(r.data.totalCount || rows.length)
      } else {
        alert(r.data.data || "No records found.")
      }
    } catch (e) { alert(e.response?.data?.data || "Preview failed.") }
    setCuLoading(false)
  }

  const cuOldSummary = rows => {
    if (!rows.length) return { qty: "0", fat: "0", snf: "0", rate: "0", amount: "0" }
    const n = rows.length
    const qty = rows.reduce((s, r) => s + parseFloat(r.qtyLtrs || 0), 0)
    const fat = rows.reduce((s, r) => s + parseFloat(r.purchaseFat || 0), 0)
    const snf = rows.reduce((s, r) => s + parseFloat(r.purchaseSnf || r.purchaseClr || 0), 0)
    const rate = rows.reduce((s, r) => s + parseFloat(r.oldRatePerLtr || 0), 0)
    const amount = rows.reduce((s, r) => s + parseFloat(r.oldRatePerLtr || 0) * parseFloat(r.qtyLtrs || 0) + parseFloat(r.oldIncentive || 0), 0)
    return { qty: qty.toFixed(3), fat: n ? (fat / n).toFixed(2) : "0", snf: n ? (snf / n).toFixed(2) : "0", rate: n ? (rate / n).toFixed(2) : "0", amount: amount.toFixed(2) }
  }
  const cuNewSummary = rows => {
    if (!rows.length) return { qty: "0", fat: "0", snf: "0", rate: "0", amount: "0" }
    const n = rows.length
    const qty = rows.reduce((s, r) => s + parseFloat(r.qtyLtrs || 0), 0)
    const fat = rows.reduce((s, r) => s + parseFloat(r.purchaseFat || 0), 0)
    const snf = rows.reduce((s, r) => s + parseFloat(r.purchaseSnf || r.purchaseClr || 0), 0)
    const rate = rows.reduce((s, r) => s + parseFloat(r.newRatePerLtr || 0), 0)
    const amount = rows.reduce((s, r) => s + parseFloat(r.newTotal || 0), 0)
    return { qty: qty.toFixed(3), fat: n ? (fat / n).toFixed(2) : "0", snf: n ? (snf / n).toFixed(2) : "0", rate: n ? (rate / n).toFixed(2) : "0", amount: amount.toFixed(2) }
  }

  const cuApplyManipulate = () => {
    const by = parseFloat(cuOvBy)
    if (isNaN(by) || by === 0) return alert("Enter a non-zero value in the 'By' field.")
    const condMin = cuOvCondMin !== "" ? parseFloat(cuOvCondMin) : null
    const condMax = cuOvCondMax !== "" ? parseFloat(cuOvCondMax) : null
    const dir = cuOvAction === "decrease" ? -1 : 1
    const getCondVal = r => {
      switch (cuOvCondField) {
        case "fat": return parseFloat(r.purchaseFat || 0)
        case "snf": return parseFloat(r.purchaseSnf || 0)
        case "clr": return parseFloat(r.purchaseClr || 0)
        case "rate": return parseFloat(r.newRatePerLtr || 0)
        default: return parseFloat(r.qtyLtrs || 0)
      }
    }
    setCuPreviewRows(prev => prev.map(r => {
      const condVal = getCondVal(r)
      const inRange = (condMin === null || condVal >= condMin) && (condMax === null || condVal <= condMax)
      if (!inRange) return r
      let fat = parseFloat(r.purchaseFat || 0)
      let snf = parseFloat(r.purchaseSnf || 0)
      let clr = parseFloat(r.purchaseClr || 0)
      let qty = parseFloat(r.qtyLtrs || 0)
      let rate = parseFloat(r.newRatePerLtr || 0)
      if (cuOvField === "qty") qty = Math.max(0, parseFloat((qty + dir * by).toFixed(3)))
      if (cuOvField === "fat") fat = Math.max(0, parseFloat((fat + dir * by).toFixed(2)))
      if (cuOvField === "snf") snf = Math.max(0, parseFloat((snf + dir * by).toFixed(2)))
      if (cuOvField === "clr") clr = Math.max(0, parseFloat((clr + dir * by).toFixed(2)))
      if (cuOvField === "rate") rate = Math.max(0, parseFloat((rate + dir * by).toFixed(2)))
      const inc = parseFloat(r.newIncentive || 0)
      const newTotal = parseFloat((rate * qty + inc).toFixed(2))
      return { ...r, qtyLtrs: qty, purchaseFat: fat, purchaseSnf: snf, purchaseClr: clr, newRatePerLtr: rate, newTotal }
    }))
  }

  const handleCuSave = async () => {
    if (!cuPreviewRows.length) return
    if (!window.confirm(`Update ${cuTotal} CC purchase record(s)? This cannot be undone.`)) return
    setCuSaving(true); setCuResult(null)
    try {
      const hasManual = cuPreviewRows.some((r, i) => {
        const o = cuOrigRows[i]; if (!o) return false
        return parseFloat(r.qtyLtrs) !== parseFloat(o.qtyLtrs) ||
          parseFloat(r.purchaseFat) !== parseFloat(o.purchaseFat) ||
          parseFloat(r.purchaseSnf) !== parseFloat(o.purchaseSnf) ||
          parseFloat(r.purchaseClr) !== parseFloat(o.purchaseClr) ||
          parseFloat(r.newRatePerLtr) !== parseFloat(o.newRatePerLtr) ||
          parseFloat(r.newIncentive) !== parseFloat(o.newIncentive)
      })
      const payload = hasManual
        ? { manualOverrides: cuPreviewRows.map(r => ({ id: r.id, fat: r.purchaseFat, snf: r.purchaseSnf, clr: r.purchaseClr, qtyLtrs: r.qtyLtrs, ratePerLtr: r.newRatePerLtr, incentive: r.newIncentive })) }
        : cuBuildPayload()
      const res = await api.post("bulk-update-cc-purchases", payload)
      setCuResult({ success: res.data.success, message: res.data.data, updated: res.data.updated, failed: res.data.failed, errors: res.data.errors || [] })
      if (res.data.success) { loadData(1); setCuPreviewRows([]); setCuOrigRows([]) }
    } catch (e) {
      setCuResult({ success: false, message: e.response?.data?.data || "Update failed.", updated: 0, failed: 0, errors: [] })
    }
    setCuSaving(false)
  }

  // â”€â”€â”€ Bulk Purchase Session Update handlers â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  const bsuBlankRow = () => ({
    id: null,
    routeNo: "", routeName: "", routeId: null, routeLookupState: "",
    vendorNo: "", vendorName: "", vendorId: null, vendorLookupState: "",
    milkType: "3", qty: "", fat: "", snf: "", clr: "",
  })

  const resetBsu = () => {
    setBsuCompany(""); setBsuPlant(""); setBsuCC(""); setBsuDate(""); setBsuShift("")
    setBsuPlants([]); setBsuCCs([]); setBsuRows([]); setBsuCurrentRow(1)
    setBsuAlert(null); setBsuPreviewDone(false); setBsuResult(null)
  }

  const openBsu = () => {
    resetBsu()
    api.get("companies").then(r => {
      const list = arr(r); setCompanies(list)
      if (list.length <= 1) api.get("plants").then(r2 => setBsuPlants(arr(r2))).catch(() => { })
    }).catch(() => { api.get("plants").then(r2 => setBsuPlants(arr(r2))).catch(() => { }) })
    setBsuOpen(true)
  }

  const onBsuCompany = async v => {
    setBsuCompany(v); setBsuPlant(""); setBsuCC(""); setBsuPlants([]); setBsuCCs([])
    setBsuPreviewDone(false); setBsuRows([]); setBsuAlert(null)
    try { setBsuPlants(arr(await (v ? api.get("plants-by-company/" + v) : api.get("plants")))) } catch (e) { }
  }
  const onBsuPlant = async v => {
    setBsuPlant(v); setBsuCC(""); setBsuCCs([]); setBsuPreviewDone(false); setBsuRows([]); setBsuAlert(null)
    if (v) try { setBsuCCs(arr(await api.get("chillings-by-plant/" + v))) } catch (e) { }
  }
  const onBsuCC = v => {
    setBsuCC(v); setBsuPreviewDone(false); setBsuRows([]); setBsuAlert(null)
  }

  const handleBsuPreview = async () => {
    if (!bsuCC) return alert("Chilling Center is required.")
    if (!bsuDate) return alert("Date is required.")
    if (bsuShift === "") return alert("Shift is required.")
    setBsuLoading(true); setBsuRows([]); setBsuAlert(null); setBsuResult(null)
    try {
      const r = await api.get(`cc-session-preview?chillingCenter=${bsuCC}&date=${bsuDate}&shift=${bsuShift}`)
      if (r.data.success) {
        const loaded = (r.data.data || []).map(rec => ({
          id: rec.id,
          routeNo: rec.routeNo || "",
          routeName: rec.routeName || "",
          routeId: rec.routeId || null,
          routeLookupState: rec.routeName ? "ok" : "",
          vendorNo: rec.vendorNo || "",
          vendorName: rec.vendorName || "",
          vendorId: rec.vendorId || null,
          vendorLookupState: rec.vendorName ? "ok" : "",
          milkType: String(rec.milkType || 3),
          qty: rec.qty != null ? String(rec.qty) : "",
          fat: rec.fat != null ? String(rec.fat) : "",
          snf: rec.snf != null ? String(rec.snf) : "",
          clr: rec.clr != null ? String(rec.clr) : "",
        }))
        // Always have at least 1 blank row
        const rows = loaded.length > 0 ? loaded : [bsuBlankRow()]
        setBsuRows(rows)
        setBsuCurrentRow(1)
        setBsuPreviewDone(true)
        if (r.data.message) setBsuAlert({ type: "info", msg: r.data.message })
      } else {
        setBsuAlert({ type: "error", msg: r.data.data || "Preview failed." })
      }
    } catch (e) {
      setBsuAlert({ type: "error", msg: e.response?.data?.data || "Preview failed." })
    }
    setBsuLoading(false)
  }

  // Route lookup for BSU rows
  const bsuLookupRoute = async (rowIdx, num) => {
    if (!num) return
    setBsuRows(prev => prev.map((r, i) => i === rowIdx ? { ...r, routeLookupState: "loading" } : r))
    try {
      const res = await api.get(`lookup-route-by-number?number=${encodeURIComponent(num)}&chillingCenter=${bsuCC}`)
      setBsuRows(prev => prev.map((r, i) => i === rowIdx ? {
        ...r,
        routeName: res.data.success ? (res.data.data?.routeName || "NOT FOUND") : "NOT FOUND",
        routeId: res.data.success ? res.data.data?.id : null,
        routeLookupState: res.data.success ? "ok" : "err",
      } : r))
    } catch (e) {
      setBsuRows(prev => prev.map((r, i) => i === rowIdx ? { ...r, routeName: "NOT FOUND", routeId: null, routeLookupState: "err" } : r))
    }
  }

  // Vendor lookup for BSU rows
  const bsuLookupVendor = async (rowIdx, num) => {
    if (!num) return
    const routeId = bsuRows[rowIdx]?.routeId || 0
    setBsuRows(prev => prev.map((r, i) => i === rowIdx ? { ...r, vendorLookupState: "loading" } : r))
    try {
      const res = await api.get(`lookup-vendor-by-number?number=${encodeURIComponent(num)}&chillingCenter=${bsuCC}&route=${routeId}`)
      setBsuRows(prev => prev.map((r, i) => i === rowIdx ? {
        ...r,
        vendorName: res.data.success ? (res.data.data?.vendorName || "NOT FOUND") : "NOT FOUND",
        vendorId: res.data.success ? res.data.data?.id : null,
        milkType: res.data.success ? String(res.data.data?.milkType || 3) : r.milkType,
        vendorLookupState: res.data.success ? "ok" : "err",
      } : r))
    } catch (e) {
      setBsuRows(prev => prev.map((r, i) => i === rowIdx ? { ...r, vendorName: "NOT FOUND", vendorId: null, vendorLookupState: "err" } : r))
    }
  }

  const setBsuRowField = (i, field, val) =>
    setBsuRows(prev => prev.map((r, idx) => idx === i ? { ...r, [field]: val } : r))

  // Row manipulation helpers (currentRow is 1-indexed)
  const bsuInsertAt = (idx) => {   // idx = 0-based position
    const safeIdx = Math.min(Math.max(0, idx), bsuRows.length)
    setBsuRows(prev => [...prev.slice(0, safeIdx), bsuBlankRow(), ...prev.slice(safeIdx)])
    setBsuCurrentRow(safeIdx + 1)
  }
  const bsuDeleteAt = (idx) => {  // idx = 0-based position
    if (bsuRows.length <= 1) { setBsuRows([bsuBlankRow()]); setBsuCurrentRow(1); return }
    setBsuRows(prev => prev.filter((_, i) => i !== idx))
    setBsuCurrentRow(prev => Math.min(prev, bsuRows.length - 1) || 1)
  }

  const handleBsuSave = async () => {
    if (!bsuCC || !bsuDate || bsuShift === "") return alert("Please fill all required header fields.")
    if (!bsuRows.length) return alert("No rows to save.")
    const validRows = bsuRows.filter(r => r.routeId || r.vendorId || r.qty || r.fat)
    if (!validRows.length) return alert("Add at least one row with data before saving.")
    setBsuSaving(true); setBsuResult(null)
    try {
      const res = await api.post("bulk-session-update-cc-purchases", {
        chillingCenter: bsuCC,
        date: bsuDate,
        shift: bsuShift,
        rows: bsuRows.map(r => ({
          id: r.id || null,
          routeId: r.routeId || null,
          vendorId: r.vendorId || null,
          milkType: r.milkType || "3",
          qty: r.qty || 0,
          fat: r.fat || 0,
          snf: r.snf || 0,
          clr: r.clr || 0,
        }))
      })
      setBsuResult({ success: res.data.success, message: res.data.data, errors: res.data.errors || [] })
      if (res.data.success) { loadData(1); handleBsuPreview() }  // reload preview
    } catch (e) {
      setBsuResult({ success: false, message: e.response?.data?.data || "Save failed.", errors: [] })
    }
    setBsuSaving(false)
  }

  // Auto-lookup: Route Number â†’ Route Name
  const lookupRoute = async (rowIdx, num) => {
    if (!num) return
    setBpRowField(rowIdx, "routeLookupState", "loading")
    try {
      const r = await api.get(`lookup-route-by-number?number=${encodeURIComponent(num)}&chillingCenter=${bpCC}`)
      if (r.data.success) {
        const rt = r.data.data
        setBpRows(prev => prev.map((row, i) => i === rowIdx
          ? { ...row, routeName: rt.routeName, routeId: rt.id, routeLookupState: "ok" } : row))
      } else {
        setBpRows(prev => prev.map((row, i) => i === rowIdx
          ? { ...row, routeName: "NOT FOUND", routeId: null, routeLookupState: "err" } : row))
      }
    } catch (e) {
      setBpRows(prev => prev.map((row, i) => i === rowIdx
        ? { ...row, routeName: "NOT FOUND", routeId: null, routeLookupState: "err" } : row))
    }
  }

  // Auto-lookup: Vendor Number â†’ Vendor Name + Milk Type
  const lookupVendor = async (rowIdx, num) => {
    if (!num) return
    const routeId = bpRows[rowIdx]?.routeId || 0
    setBpRowField(rowIdx, "vendorLookupState", "loading")
    try {
      const r = await api.get(`lookup-vendor-by-number?number=${encodeURIComponent(num)}&chillingCenter=${bpCC}&route=${routeId}`)
      if (r.data.success) {
        const v = r.data.data
        setBpRows(prev => prev.map((row, i) => i === rowIdx
          ? { ...row, vendorName: v.vendorName, vendorId: v.id, milkType: String(v.milkType || 3), vendorLookupState: "ok" } : row))
      } else {
        setBpRows(prev => prev.map((row, i) => i === rowIdx
          ? { ...row, vendorName: "NOT FOUND", vendorId: null, vendorLookupState: "err" } : row))
      }
    } catch (e) {
      setBpRows(prev => prev.map((row, i) => i === rowIdx
        ? { ...row, vendorName: "NOT FOUND", vendorId: null, vendorLookupState: "err" } : row))
    }
  }
  // Auto-compute CLR/SNF and KG when fields change
  const setBpRowField = (i, field, val) => setBpRows(r => r.map((row, idx) => {
    if (idx !== i) return row
    const updated = { ...row, [field]: val }
    // Auto-compute CLR <-> SNF using Tamil Nadu formula: SNF = CLR/4 + 0.2*FAT + 0.36
    const fat = parseFloat(field === "purchaseFat" ? val : updated.purchaseFat) || 0
    const formula = bpCompanySettings?.snf_clr_formula || "Tamil Nadu"
    if (formula.includes("Tamil Nadu") || formula.includes("CLR/4")) {
      if (bpMode === "SNF" && (field === "purchaseSnf" || field === "purchaseFat")) {
        const snf = parseFloat(field === "purchaseSnf" ? val : updated.purchaseSnf) || 0
        if (snf > 0 && fat > 0) updated.purchaseClr = Math.max(0, (snf - 0.2 * fat - 0.36) * 4).toFixed(2)
      } else if (bpMode === "CLR" && (field === "purchaseClr" || field === "purchaseFat")) {
        const clr = parseFloat(field === "purchaseClr" ? val : updated.purchaseClr) || 0
        if (clr > 0 && fat > 0) updated.purchaseSnf = (clr / 4 + 0.2 * fat + 0.36).toFixed(2)
      }
    }
    // Auto-compute Qty KG from Ltrs
    if (field === "qty" || field === "milkType") {
      const qtyLtrs = parseFloat(field === "qty" ? val : updated.qty) || 0
      const mType = field === "milkType" ? val : updated.milkType
      const factor = mType === "2"
        ? parseFloat(bpCompanySettings?.liter_to_kg_buffalo || 1.03)
        : parseFloat(bpCompanySettings?.liter_to_kg_cow || 1.03)
      if (qtyLtrs > 0) updated.qtyKg = (qtyLtrs * factor).toFixed(3)
    }
    return updated
  }))

  const saveBp = async () => {
    if (!bpPlant) return alert("Please select a Plant.")
    if (!bpCC) return alert("Please select a Chilling Center.")
    if (!bpDate) return alert("Date is required.")
    if (!bpRows.length) return alert("Add at least one row.")
    const validRows = bpRows.filter(r => r.purchaseFat && parseFloat(r.purchaseFat) > 0)
    if (!validRows.length) return alert("At least one row must have a FAT value.")
    const badRoute = bpRows.findIndex(r => !r.routeId)
    if (badRoute > -1) return alert(`Row ${badRoute + 1}: Route not resolved. Enter a valid Route No.`)
    const badVendor = bpRows.findIndex(r => !r.vendorId)
    if (badVendor > -1) return alert(`Row ${badVendor + 1}: Vendor not resolved. Enter a valid Vendor No.`)
    setBpSaving(true)
    try {
      const resp = await api.post("bulk-create-cc-purchases", {
        chillingCenter: bpCC,
        purchaseDate: bpDate,
        shift: bpShift,
        entryMode: bpMode,
        rows: bpRows.map(r => ({
          route: r.routeId,
          vendor: r.vendorId,
          milkType: r.milkType,
          qtyLtrs: r.qty || 0,
          qtyKg: r.qtyKg || 0,
          purchaseFat: r.purchaseFat,
          purchaseSnf: r.purchaseSnf || "",
          purchaseClr: r.purchaseClr || "",
        }))
      })
      if (resp.data.success) {
        alert(resp.data.data || "Saved successfully.")
        setBpOpen(false); loadData(1)
      } else {
        const errs = resp.data.errors ? Object.values(resp.data.errors).flat().join("\n") : (resp.data.data || "Save failed.")
        alert(errs)
      }
    } catch (e) { alert("Network error. Please try again.") }
    setBpSaving(false)
  }

  // Ã¢â€â‚¬Ã¢â€â‚¬ load data Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬
  const loadData = useCallback(async (p = 1) => {
    setPageLoad(true); setSelected([])
    try {
      const params = new URLSearchParams({ per_page: 50, page: p })
      if (filterDate) params.append("dateFrom", filterDate)
      if (filterDateTo) params.append("dateTo", filterDateTo)
      if (filterShift) params.append("shift", filterShift)
      if (filterMilk) params.append("milkType", filterMilk)
      if (search) params.append("search", search)
      const r = await api.get("cc-purchases?" + params.toString())
      const d = r.data?.data
      setPurchases(Array.isArray(d) ? d : d?.data || [])
      setTotalPages(d?.last_page || 1); setPage(p)
    } catch (e) { setPurchases([]) }
    setPageLoad(false)
  }, [filterDate, filterDateTo, filterShift, filterMilk, search])

  const loadDeleted = useCallback(async (p = 1) => {
    setPageLoad(true)
    try {
      const params = new URLSearchParams({ per_page: 50, page: p })
      if (dSearch) params.append("search", dSearch)
      if (dFilterDate) params.append("dateFrom", dFilterDate)
      if (dFilterDateTo) params.append("dateTo", dFilterDateTo)
      const r = await api.get("cc-deleted-purchases?" + params.toString())
      const d = r.data?.data
      setDeleted(Array.isArray(d) ? d : d?.data || [])
      setDTotalPages(d?.last_page || 1); setDPage(p)
    } catch (e) { setDeleted([]) }
    setPageLoad(false)
  }, [dSearch])

  // â”€â”€â”€ More Actions â€” Shared cascade helper â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  const loadMorePlants = async (setP, setC, setCR) => {
    try {
      const list = arr(await api.get("companies")); setCompanies(list)
      if (list.length <= 1) { try { setP(arr(await api.get("plants"))) } catch(e){} }
    } catch(e) { try { setP(arr(await api.get("plants"))) } catch(e2){} }
  }
  const morePlantChange = async (v, setPlant, setCC, setCCs) => {
    setPlant(v); setCC(""); setCCs([])
    if (v) try { setCCs(arr(await api.get("chillings-by-plant/" + v))) } catch(e){}
  }

  // â”€â”€â”€ Excel Import Single Shift â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  const openExS = () => {
    setExSPlant(""); setExSCC(""); setExSDate(""); setExSShift("0")
    setExSPlants([]); setExSCCs([]); setExSFile(null); setExSPreview([]); setExSResult(null)
    loadMorePlants(setExSPlants)
    setExSOpen(true)
  }
  const handleExSPreview = async () => {
    if (!exSCC) return alert("Chilling Center is required.")
    if (!exSDate) return alert("Date is required.")
    if (!exSFile) return alert("Please choose a file.")
    setExSLoading(true); setExSPreview([]); setExSResult(null)
    try {
      const fd = new FormData()
      fd.append("file", exSFile); fd.append("chillingCenter", exSCC)
      fd.append("date", exSDate); fd.append("shift", exSShift)
      const r = await api.post("cc-purchase-excel-preview", fd, { headers: { "Content-Type": "multipart/form-data" } })
      setExSPreview(r.data.data || r.data.rows || [])
      if (r.data.message) setExSResult({ success: true, message: r.data.message })
    } catch(e) { setExSResult({ success: false, message: e.response?.data?.data || e.response?.data?.message || "Preview failed." }) }
    setExSLoading(false)
  }
  const handleExSSave = async () => {
    if (!exSPreview.length) return
    setExSSaving(true)
    try {
      const r = await api.post("cc-purchase-excel-save", { chillingCenter: exSCC, date: exSDate, shift: exSShift, rows: exSPreview })
      setExSResult({ success: true, message: r.data.data || r.data.message || "Import saved." })
      loadData(page)
    } catch(e) { setExSResult({ success: false, message: e.response?.data?.data || "Save failed." }) }
    setExSSaving(false)
  }

  // â”€â”€â”€ Excel Import Multi Shift â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  const openExM = () => {
    setExMPlant(""); setExMCC(""); setExMPlants([]); setExMCCs([])
    setExMFile(null); setExMPreview([]); setExMResult(null)
    loadMorePlants(setExMPlants)
    setExMOpen(true)
  }
  const handleExMPreview = async () => {
    if (!exMCC) return alert("Chilling Center is required.")
    if (!exMFile) return alert("Please choose a file.")
    setExMLoading(true); setExMPreview([]); setExMResult(null)
    try {
      const fd = new FormData()
      fd.append("file", exMFile); fd.append("chillingCenter", exMCC)
      const r = await api.post("cc-purchase-multi-shift-preview", fd, { headers: { "Content-Type": "multipart/form-data" } })
      setExMPreview(r.data.data || r.data.rows || [])
      if (r.data.message) setExMResult({ success: true, message: r.data.message })
    } catch(e) { setExMResult({ success: false, message: e.response?.data?.data || "Preview failed." }) }
    setExMLoading(false)
  }
  const handleExMSave = async () => {
    if (!exMPreview.length) return
    setExMSaving(true)
    try {
      const r = await api.post("cc-purchase-multi-shift-save", { chillingCenter: exMCC, rows: exMPreview })
      setExMResult({ success: true, message: r.data.data || r.data.message || "Import saved." })
      loadData(page)
    } catch(e) { setExMResult({ success: false, message: e.response?.data?.data || "Save failed." }) }
    setExMSaving(false)
  }

  // â”€â”€â”€ Download Excel Templates â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  const downloadTemplateSingle = () => {
    const hdr = "SerialNo,VendorNumber,MilkType,QtyLtrs,FAT,SNF,CLR,WaterPercent"
    const blob = new Blob([hdr + "\n"], { type: "text/csv" })
    const a = document.createElement("a"); a.href = URL.createObjectURL(blob)
    a.download = "cc_purchase_single_shift_template.csv"; a.click()
  }
  const downloadTemplateMulti = () => {
    const hdr = "SerialNo,VendorNumber,MilkType,Date,Shift,QtyLtrs,FAT,SNF,CLR,WaterPercent"
    const blob = new Blob([hdr + "\n"], { type: "text/csv" })
    const a = document.createElement("a"); a.href = URL.createObjectURL(blob)
    a.download = "cc_purchase_multi_shift_template.csv"; a.click()
  }

  // â”€â”€â”€ FTP Import â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  const openFtpI = () => {
    setFtpIPlant(""); setFtpICC(""); setFtpIDate(""); setFtpIShift("0")
    setFtpIPlants([]); setFtpICCs([]); setFtpIResult(null)
    loadMorePlants(setFtpIPlants)
    setFtpIOpen(true)
  }
  const handleFtpImport = async () => {
    if (!ftpICC) return alert("Chilling Center is required.")
    if (!ftpIDate) return alert("Date is required.")
    setFtpILoading(true); setFtpIResult(null)
    try {
      const r = await api.post("cc-purchase-ftp-import", { chillingCenter: ftpICC, date: ftpIDate, shift: ftpIShift })
      setFtpIResult({ success: true, message: r.data.data || r.data.message || "FTP Import complete." })
      loadData(page)
    } catch(e) { setFtpIResult({ success: false, message: e.response?.data?.data || "FTP Import failed." }) }
    setFtpILoading(false)
  }

  // â”€â”€â”€ FTP Export â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  const openFtpE = () => {
    setFtpEPlant(""); setFtpECC(""); setFtpEDate("")
    setFtpEPlants([]); setFtpECCs([]); setFtpEResult(null)
    loadMorePlants(setFtpEPlants)
    setFtpEOpen(true)
  }
  const handleFtpExport = async () => {
    if (!ftpECC) return alert("Chilling Center is required.")
    if (!ftpEDate) return alert("Date is required.")
    setFtpELoading(true); setFtpEResult(null)
    try {
      const r = await api.post("cc-purchase-ftp-export", { chillingCenter: ftpECC, date: ftpEDate })
      setFtpEResult({ success: true, message: r.data.data || r.data.message || "FTP Export complete." })
    } catch(e) { setFtpEResult({ success: false, message: e.response?.data?.data || "FTP Export failed." }) }
    setFtpELoading(false)
  }

  // â”€â”€â”€ CSV Download â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€

  // --- Procurement Comparison Summary Handlers ---
  const openCmpModal = () => {
    setCmpPlant(""); setCmpCC(""); setCmpRoute(""); setCmpCenter("")
    setCmpPlants([]); setCmpCCs([]); setCmpRoutes([]); setCmpCenters([])
    setCmpFrom(""); setCmpTo(""); setCmpDisplay("all"); setCmpBasis("qty_only")
    setCmpParams([]); setCmpResult(null)
    loadMorePlants(setCmpPlants)
    setCmpOpen(true)
  }
  const onCmpPlant = async v => {
    setCmpPlant(v); setCmpCC(""); setCmpRoute(""); setCmpCenter("")
    setCmpCCs([]); setCmpRoutes([]); setCmpCenters([])
    if (v) try { setCmpCCs(arr(await api.get("chillings-by-plant/" + v))) } catch(e){}
  }
  const onCmpCC = async v => {
    setCmpCC(v); setCmpRoute(""); setCmpCenter("")
    setCmpRoutes([]); setCmpCenters([])
    if (v) try { setCmpRoutes(arr(await api.get("route-cc/" + v))) } catch(e){}
  }
  const onCmpRoute = async v => {
    setCmpRoute(v); setCmpCenter(""); setCmpCenters([])
    if (v) try { setCmpCenters(arr(await api.get("collection-center-route/" + v))) } catch(e){}
  }
  const cmpParamOptions = ["Quantity","FAT","SNF","TS","Amount"]
  const toggleCmpParam = p => setCmpParams(prev => prev.includes(p) ? prev.filter(x => x !== p) : [...prev, p])
  const handleCmpPrint = async () => {
    if (!cmpCC) return alert("Chilling Center is required.")
    if (!cmpFrom || !cmpTo) return alert("Period From and To are required.")
    setCmpLoading(true); setCmpResult(null)
    try {
      const r = await api.post("cc-purchase-comparison-summary", {
        chillingCenter: cmpCC, route: cmpRoute || "", collectionCenter: cmpCenter || "",
        dateFrom: cmpFrom, dateTo: cmpTo, displayEntries: cmpDisplay,
        comparisonBasis: cmpBasis, displayParams: cmpParams
      }, { responseType: "blob" })
      const blob = new Blob([r.data], { type: "text/csv" })
      const a = document.createElement("a"); a.href = URL.createObjectURL(blob)
      a.download = `cc_comparison_${cmpFrom}_to_${cmpTo}.csv`; a.click()
      setCmpResult({ success: true, message: "Comparison summary CSV downloaded." })
    } catch(e) {
      try { const t = await e.response.data.text(); const j = JSON.parse(t); setCmpResult({ success: false, message: j.data || "Comparison failed." }) }
      catch(_) { setCmpResult({ success: false, message: "Comparison summary failed." }) }
    }
    setCmpLoading(false)
  }

  // --- Entry Mode Color Map (Purchase Color Marking) ---
  const entryModeColorMap = {
    analyzer:     { color: "#333333", bg: "#e8e8e8", label: "Captured from Analyzer/Scale in App" },
    manual:       { color: "#5b21b6", bg: "#ede9fe", label: "Manual Entry in App" },
    analyzer_mod: { color: "#78350f", bg: "#fef3c7", label: "Entry Modified by capturing again from Analyzer/Scale in App" },
    manual_mod:   { color: "#dc2626", bg: "#fee2e2", label: "Entry Modified manually from App" },
    server:       { color: "#b45309", bg: "#fef3c7", label: "Added from Server" },
    server_mod:   { color: "#7c3aed", bg: "#f3e8ff", label: "Updated from Server" },
    import:       { color: "#047857", bg: "#d1fae5", label: "Imported from Server" },
    ftp_import:   { color: "#047857", bg: "#d1fae5", label: "Imported from Server" },
    multi_shift_import: { color: "#047857", bg: "#d1fae5", label: "Imported from Server" },
    SNF:          { color: "#333333", bg: "transparent", label: "" },
    CLR:          { color: "#333333", bg: "transparent", label: "" },
  }
  const getRowStyle = (entryMode) => {
    const m = entryModeColorMap[entryMode]
    if (m && m.bg !== "transparent") return { borderLeft: `4px solid ${m.color}`, background: m.bg }
    return {}
  }
  const openCsvDl = () => {
    setCsvPlant(""); setCsvCC(""); setCsvRoute(""); setCsvDate(""); setCsvShift("")
    setCsvPlants([]); setCsvCCs([]); setCsvRoutes([])
    loadMorePlants(setCsvPlants)
    setCsvOpen(true)
  }
  const handleCsvDownload = async () => {
    if (!csvCC) return alert("Chilling Center is required.")
    if (!csvDate) return alert("Date is required.")
    setCsvLoading(true)
    try {
      const r = await api.post("cc-purchase-csv-download", { chillingCenter: csvCC, route: csvRoute, date: csvDate, shift: csvShift }, { responseType: "blob" })
      const blob = new Blob([r.data], { type: "text/csv" })
      const a = document.createElement("a"); a.href = URL.createObjectURL(blob)
      a.download = `cc_purchases_${csvDate}.csv`; a.click()
      setCsvOpen(false)
    } catch(e) { alert("Download failed.") }
    setCsvLoading(false)
  }

  // â”€â”€â”€ Additional Incentive Update â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  const openIncUpdate = () => {
    setIncPlant(""); setIncCC(""); setIncDate(""); setIncShift(""); setIncAmount("")
    setIncPlants([]); setIncCCs([]); setIncResult(null)
    loadMorePlants(setIncPlants)
    setIncOpen(true)
  }
  const handleIncUpdate = async () => {
    if (!incCC) return alert("Chilling Center is required.")
    if (!incDate) return alert("Date is required.")
    if (!incAmount || parseFloat(incAmount) === 0) return alert("Incentive amount is required.")
    setIncLoading(true); setIncResult(null)
    try {
      const r = await api.post("cc-purchase-incentive-update", { chillingCenter: incCC, date: incDate, shift: incShift, incentiveAmount: incAmount })
      setIncResult({ success: true, message: r.data.data || r.data.message || "Incentive updated." })
      loadData(page)
    } catch(e) { setIncResult({ success: false, message: e.response?.data?.data || "Update failed." }) }
    setIncLoading(false)
  }

  useEffect(() => { loadData(1) }, [filterDate, filterDateTo, filterShift, filterMilk])
  useEffect(() => { if (activeTab === "deleted") loadDeleted(1) }, [activeTab])

  const doSearch = e => { e.preventDefault(); loadData(1) }
  const doDSearch = e => { e.preventDefault(); loadDeleted(1) }

  // Ã¢â€â‚¬Ã¢â€â‚¬ delete / restore Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬
  const doDelete = async () => {
    try {
      const r = await api.delete("delete-cc-purchase/" + deleteId)
      if (r.data.success) { loadData(page) }
    } catch (e) { }
  }
  const doBulkDelete = async () => {
    if (!selected.length) return
    try {
      const r = await api.post("delete-multiple-cc-purchases", { ids: selected })
      if (r.data.success) { setSelected([]); loadData(1) }
    } catch (e) { }
  }
  const doRestore = async id => {
    try {
      const r = await api.post("restore-cc-purchase/" + id)
      if (r.data.success) { loadDeleted(dPage) }
    } catch (e) { }
  }

  // Ã¢â€â‚¬Ã¢â€â‚¬ CSV export Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬
  const exportCSV = () => {
    if (!purchases.length) return
    const h = ["#", "Chilling Center", "Route", "Center Name", "Date", "Shift", "Serial", "Milk Type", "No of Cans", "Qty Unit", "Qty (Ltrs)", "Qty (KG)", "FAT", "SNF", "CLR", "Water %", "Rate Per Ltr", "Rate Per KG", "Incentive", "Reception Time", "Quality Time"]
    let csv = h.join(",") + "\n"
    purchases.forEach((p, i) => {
      csv += [i + 1, `"${p.chillingCenterName || ""}"`, `"${p.routeName || ""}"`, `"${p.centerName || ""}"`,
      p.purchaseDate || "", p.shift == 0 ? "AM" : "PM", p.serialNo || "",
      p.milkType == 1 ? "Cow" : p.milkType == 2 ? "Buffalo" : "Common",
      p.purchaseCans || "", p.qtyUnit || "", p.qtyLtrs || "", p.qtyKg || "",
      p.purchaseFat || "", p.purchaseSnf || "", p.purchaseClr || "", p.waterPercent || "",
      p.ratePerLtr || "", p.ratePerKg || "", p.incentive || "",
      p.receptionTime || "", p.qualityTime || ""].join(",") + "\n"
    })
    const b = new Blob(["\uFEFF" + csv], { type: "text/csv" })
    const a = document.createElement("a"); a.href = URL.createObjectURL(b)
    a.download = "cc_purchases_" + new Date().toISOString().slice(0, 10) + ".csv"; a.click()
  }

  // â”€â”€â”€â”€ select all â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  const allSelected = purchases.length > 0 && selected.length === purchases.length
  const toggleAll = () => setSelected(allSelected ? [] : purchases.map(p => p.id))
  const toggleOne = id => setSelected(s => s.includes(id) ? s.filter(x => x !== id) : [...s, id])

  // â”€â”€â”€â”€ pagination helper â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  const Pager = ({ cur, total, onChange }) => (
    <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", gap: 4, marginTop: 8 }}>
      <button className="btn btn-sm btn-outline-secondary" onClick={() => onChange(1)} disabled={cur <= 1}>Â«</button>
      <button className="btn btn-sm btn-outline-secondary" onClick={() => onChange(cur - 1)} disabled={cur <= 1}>â€¹</button>
      <span style={{ padding: "2px 10px", background: "#0d6efd", color: "#fff", borderRadius: 4, fontSize: 13 }}>{cur}</span>
      <button className="btn btn-sm btn-outline-secondary" onClick={() => onChange(cur + 1)} disabled={cur >= total}>â€º</button>
      <button className="btn btn-sm btn-outline-secondary" onClick={() => onChange(total)} disabled={cur >= total}>Â»</button>
    </div>
  )

  // â”€â”€â”€â”€ RENDER â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  const ib = (bg, icon, title, onClick, dis) => (
    <button title={title} onClick={onClick} disabled={dis}
      style={{ width: "32px", height: "32px", borderRadius: "4px", background: bg, color: "#fff", border: "none", display: "inline-flex", alignItems: "center", justifyContent: "center", fontSize: "14px", cursor: dis ? "not-allowed" : "pointer", opacity: dis ? 0.5 : 1 }}>
      <i className={`fas ${icon}`} />
    </button>
  )
  const milkBadge = t => <span className={`badge bg-${t == 1 ? "primary" : t == 2 ? "success" : "secondary"}`}>{t == 1 ? "Cow" : t == 2 ? "Buffalo" : "Common"}</span>
  const shiftBadge = s => <span className={`badge bg-${s == 0 ? "info" : "warning"}`}>{s == 0 ? "AM" : "PM"}</span>

  return (
    <>


      {/* â”€â”€â”€ Unified Header: Tabs + Icons + Search in ONE row â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */}
      <div style={{
        display: "flex", alignItems: "center", flexWrap: "wrap", gap: "6px",
        marginBottom: "10px", background: "#f8f9fa",
        borderRadius: "8px", padding: "4px 8px", border: "1px solid #dee2e6",
      }}>
        {/* Tabs */}
        {[
          { id: "active", label: "CC Purchases", icon: "fa-shopping-basket" },
          { id: "deleted", label: "Deleted CC Purchases", icon: "fa-trash-alt" },
        ].map(t => (
          <button key={t.id}
            onClick={() => { setActiveTab(t.id); if (t.id === "active") loadData(1); else loadDeleted(1); }}
            style={{
              display: "flex", alignItems: "center", gap: "5px",
              padding: "5px 12px", border: "none", borderRadius: "6px", cursor: "pointer",
              fontWeight: 600, fontSize: "13px", whiteSpace: "nowrap",
              background: activeTab === t.id ? "#0d6efd" : "transparent",
              color: activeTab === t.id ? "#fff" : "#495057",
              transition: "background 0.15s, color 0.15s",
            }}>
            <i className={`fas ${t.icon}`} style={{ fontSize: "12px" }} />
            {t.label}
          </button>
        ))}

        {/* Divider */}
        <div style={{ width: 1, height: 24, background: "#dee2e6", margin: "0 2px" }} />

        {/* Action Icons â€” Active tab */}
        {activeTab === "active" && (<>
          {canAdd(MID) && ib("#28a745", "fa-plus-square", "Add New Purchase", openBp, false)}
          {ib("#f59e0b", "fa-sync-alt", "Update Purchases", openCu, false)}
          {ib("#6f42c1", "fa-calendar-alt", "Session Update", openBsu, false)}

          {/* â”€â”€ More Actions Dropdown â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */}
          <div style={{ position: "relative", display: "inline-block" }}>
            <button
              ref={ddBtnRef}
              title="More Actions"
              onClick={() => {
                if (!ddOpen) {
                  const rect = ddBtnRef.current.getBoundingClientRect()
                  setDdPos({ top: rect.bottom + 4, left: rect.left })
                }
                setDdOpen(v => !v)
              }}
              style={{ width: 32, height: 32, borderRadius: 4, background: "#0d6efd", color: "#fff", border: "none", display: "inline-flex", alignItems: "center", justifyContent: "center", fontSize: 13, cursor: "pointer" }}>
              <i className="fas fa-caret-down" />
            </button>
          </div>

          {/* Dropdown portal â€” fixed to viewport, never clipped */}
          {ddOpen && (
            <>
              {/* Invisible overlay to catch outside clicks */}
              <div
                onClick={() => setDdOpen(false)}
                style={{ position: "fixed", inset: 0, zIndex: 9998 }}
              />
              <div
                style={{
                  position: "fixed",
                  top: ddPos.top,
                  left: ddPos.left,
                  zIndex: 9999,
                  background: "#fff",
                  border: "1px solid #dee2e6",
                  borderRadius: 6,
                  boxShadow: "0 6px 24px rgba(0,0,0,.15)",
                  minWidth: 280,
                  padding: "4px 0",
                }}>
                {[
                  { label: "Send Bulk Purchase SMS", icon: "fa-sms", action: "sms" },
                  { label: "Import Bulk Purchase From FTP", icon: "fa-server", action: "ftp_import" },
                  null,
                  { label: "Import From Excel - Single Shift", icon: "fa-file-excel", action: "excel_import_single" },
                  { label: "Download Excel Format - Single Shift", icon: "fa-file-download", action: "excel_dl_single" },
                  null,
                  { label: "Import From Excel - Multiple Shift", icon: "fa-file-excel", action: "excel_import_multi" },
                  { label: "Download Excel Format - Multiple Shift", icon: "fa-file-download", action: "excel_dl_multi" },
                  null,
                  { label: "Export Bulk Purchase To FTP", icon: "fa-upload", action: "ftp_export" },
                  { label: "Download Purchases CSV", icon: "fa-file-csv", action: "csv_dl" },
                  { label: "Print Purchase Comparison Summary", icon: "fa-print", action: "print_summary" },
                  null,
                  { label: "Additional Incentive Update", icon: "fa-percentage", action: "incentive_update" },
                  { label: "Purchase Color Marking Details", icon: "fa-palette", action: "color_details" },
                ].map((item, idx) =>
                  item === null
                    ? <div key={`sep-${idx}`} style={{ height: 1, background: "#e9ecef", margin: "4px 0" }} />
                    : <button key={item.action}
                      onClick={() => {
                        setDdOpen(false)
                        const actions = {
                          sms: openCsModal,
                          ftp_import: openFtpI,
                          excel_import_single: openExS,
                          excel_dl_single: downloadTemplateSingle,
                          excel_import_multi: openExM,
                          excel_dl_multi: downloadTemplateMulti,
                          ftp_export: openFtpE,
                          csv_dl: openCsvDl,
                          print_summary: () => openCmpModal(),
                          incentive_update: openIncUpdate,
                          color_details: () => setColorOpen(true),
                        }
                        if (actions[item.action]) actions[item.action]()
                      }}
                      style={{
                        display: "flex", alignItems: "center", gap: 10, width: "100%",
                        background: "none", border: "none", padding: "8px 16px",
                        fontSize: 13, color: "#212529", cursor: "pointer", textAlign: "left",
                      }}
                      onMouseEnter={e => e.currentTarget.style.background = "#f0f4ff"}
                      onMouseLeave={e => e.currentTarget.style.background = "none"}>
                      <i className={`fas ${item.icon}`} style={{ width: 16, color: "#0d6efd", fontSize: 13 }} />
                      {item.label}
                    </button>
                )}
              </div>
            </>
          )}

          {canDelete(MID) && ib("#dc3545", "fa-trash", selected.length > 0 ? `Delete ${selected.length}` : "Delete Selected",
            () => { if (selected.length > 0) setBulkConfirm(true); else alert("Select items first.") }, false)}
          {ib("#17a2b8", "fa-file-csv", "Export CSV", exportCSV, !purchases.length)}
          <button title={showFilter ? "Hide Filters" : "Show Filters"}
            onClick={() => setShowFilter(v => { if (v) { setFilterDate(""); setFilterDateTo(""); setFilterShift(""); setFilterMilk(""); } return !v; })}
            style={{ width: 32, height: 32, borderRadius: 4, background: showFilter ? "#0d6efd" : "#6c757d", color: "#fff", border: "none", display: "inline-flex", alignItems: "center", justifyContent: "center", fontSize: 14, cursor: "pointer" }}>
            <i className="fas fa-filter" />
          </button>
          {showFilter && (<>
            <input type="date" className="form-control form-control-sm" value={filterDate} onChange={e => setFilterDate(e.target.value)} style={{ height: 32, width: 130 }} title="Date From" />
            <input type="date" className="form-control form-control-sm" value={filterDateTo} onChange={e => setFilterDateTo(e.target.value)} style={{ height: 32, width: 130 }} title="Date To" />
            <select className="form-control form-control-sm" value={filterShift} onChange={e => setFilterShift(e.target.value)} style={{ height: 32, width: 80, color: "#212529" }}>
              <option value="">Shift</option><option value="0">AM</option><option value="1">PM</option>
            </select>
            <select className="form-control form-control-sm" value={filterMilk} onChange={e => setFilterMilk(e.target.value)} style={{ height: 32, width: 100, color: "#212529" }}>
              <option value="">Milk</option><option value="1">Cow</option><option value="2">Buffalo</option><option value="3">Common</option>
            </select>
            <button className="btn btn-sm" style={{ height: 32, background: "#dc3545", color: "#fff", border: "none", borderRadius: 4 }}
              onClick={() => { setFilterDate(""); setFilterDateTo(""); setFilterShift(""); setFilterMilk(""); setShowFilter(false); }}>
              <i className="fa fa-times" />
            </button>
          </>)}
        </>)}

        {/* Deleted tab actions */}
        {activeTab === "deleted" && (<>
          <button title={dShowFilter ? "Hide Filters" : "Show Filters"}
            onClick={() => setDShowFilter(v => { if (v) { setDFilterDate(""); setDFilterDateTo(""); } return !v; })}
            style={{ width: 32, height: 32, borderRadius: 4, background: dShowFilter ? "#0d6efd" : "#6c757d", color: "#fff", border: "none", display: "inline-flex", alignItems: "center", justifyContent: "center", fontSize: 14, cursor: "pointer" }}>
            <i className="fas fa-filter" />
          </button>
          {dShowFilter && (<>
            <input type="date" className="form-control form-control-sm" value={dFilterDate}
              onChange={e => { setDFilterDate(e.target.value); }} style={{ height: 32, width: 130 }} title="Date From" />
            <input type="date" className="form-control form-control-sm" value={dFilterDateTo}
              onChange={e => { setDFilterDateTo(e.target.value); }} style={{ height: 32, width: 130 }} title="Date To" />
            <button className="btn btn-sm" style={{ height: 32, background: "#dc3545", color: "#fff", border: "none", borderRadius: 4 }}
              onClick={() => { setDFilterDate(""); setDFilterDateTo(""); setDShowFilter(false); loadDeleted(1); }}>
              <i className="fa fa-times" />
            </button>
          </>)}
        </>)}

        {/* Spacer */}
        <div style={{ flex: 1 }} />

        {/* Search â€” Active tab */}
        {activeTab === "active" && (
          <div style={{ display: "flex", alignItems: "center" }}>
            <input type="text" placeholder="Search..." value={search}
              onChange={e => { setSearch(e.target.value); setPage(1); }}
              style={{ border: "1px solid #dee2e6", borderRadius: "4px 0 0 4px", padding: "4px 10px", fontSize: "13px", width: "170px", height: "32px" }} />
            {ib("#0d6efd", "fa-search", "Search", () => loadData(1), false)}
          </div>
        )}
      </div>

      {pageLoad ? <div className="pageLoader"><img src={PageLoader} alt="Loading..." /></div> : (<>

        {/* â”€â”€ ACTIVE TAB â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */}
        {activeTab === "active" && (<>

          {/* â”€â”€â”€â”€ FILTER ROW â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */}

          {/* â”€â”€â”€â”€ TABLE â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */}
          <div className="table-responsive">
            <table className="table mb-0 dairyTbl">
              <thead><tr>
                <th><input type="checkbox" checked={allSelected} onChange={toggleAll} /></th>
                <th>#</th><th>Chilling Center</th><th>Route</th><th>Center Name</th>
                <th>Date</th><th>Shift</th><th>Serial</th><th>Milk Type</th>
                <th>No of Cans</th><th>Qty Unit</th><th>Qty (Ltrs)</th><th>Qty (KG)</th>
                <th>FAT</th><th>SNF</th><th>CLR</th><th>Water %</th>
                <th>Rate Per Ltr</th><th>Rate Per KG</th><th>Incentive</th>
                <th>Reception Time</th><th>Quality Time</th><th>Action</th>
              </tr></thead>
              <tbody>
                {purchases.length > 0 ? purchases.map((p, i) => (
                  <tr key={p.id} style={getRowStyle(p.entryMode)}>
                    <td><input type="checkbox" checked={selected.includes(p.id)} onChange={() => toggleOne(p.id)} /></td>
                    <td>{(page - 1) * 50 + i + 1}</td>
                    <td style={{ whiteSpace: "nowrap" }}>{p.chillingCenterName || p.chillingCenter}</td>
                    <td style={{ whiteSpace: "nowrap" }}>{p.routeName || p.route}</td>
                    <td style={{ whiteSpace: "nowrap" }}>{p.centerName || ""}</td>
                    <td style={{ fontSize: 12, whiteSpace: "nowrap" }}>{p.purchaseDate}</td>
                    <td>{shiftBadge(p.shift)}</td>
                    <td>{p.serialNo}</td>
                    <td>{milkBadge(p.milkType)}</td>
                    <td>{fmt(p.purchaseCans)}</td>
                    <td>{p.qtyUnit}</td>
                    <td><strong>{fmt(p.qtyLtrs)}</strong></td>
                    <td>{fmt(p.qtyKg)}</td>
                    <td style={{ fontWeight: 600, color: "#d97706" }}>{fmt(p.purchaseFat)}</td>
                    <td style={{ fontWeight: 600, color: "#0284c7" }}>{fmt(p.purchaseSnf)}</td>
                    <td>{fmt(p.purchaseClr)}</td>
                    <td>{fmt(p.waterPercent)}</td>
                    <td>â‚¹{fmt(p.ratePerLtr)}</td>
                    <td>â‚¹{fmt(p.ratePerKg)}</td>
                    <td style={{ color: "#059669", fontWeight: 600 }}>â‚¹{fmt(p.incentive) || "0"}</td>
                    <td style={{ fontSize: 11 }}>{p.receptionTime}</td>
                    <td style={{ fontSize: 11 }}>{p.qualityTime}</td>
                    <td style={{ whiteSpace: "nowrap" }}>
                      {canEdit(MID) && <button style={{ width: "28px", height: "28px", borderRadius: "4px", background: "#0d6efd", color: "#fff", border: "none", display: "inline-flex", alignItems: "center", justifyContent: "center", fontSize: "12px", cursor: "pointer" }} title="Edit"><i className="fas fa-edit" /></button>}
                    </td>
                  </tr>
                )) : <tr><td colSpan={23}><center style={{ padding: 20, color: "#6c757d" }}>No CC purchases found</center></td></tr>}
              </tbody>
            </table>
          </div>
          <Pager cur={page} total={totalPages} onChange={p => { setPage(p); loadData(p) }} />
        </>)}

        {/* â•â• DELETED TAB â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â• */}
        {activeTab === "deleted" && (<>
          <div className="table-responsive">
            <table className="table mb-0 dairyTbl">
              <thead><tr>
                <th>#</th><th>CC</th><th>Date</th><th>Shift</th><th>S.No</th>
                <th>Vendor</th><th>Milk</th><th>Qty (ltrs)</th><th>Qty (KG)</th>
                <th>FAT</th><th>SNF</th><th>Rate Per Ltr</th><th>Rate Per KG</th>
                <th>Deleted By</th><th>Deleted At</th><th>Action</th>
              </tr></thead>
              <tbody>
                {deleted.length > 0 ? deleted.map((p, i) => (
                  <tr key={p.id}>
                    <td>{(dPage - 1) * 50 + i + 1}</td>
                    <td>{p.chillingCenterName || p.chillingCenter}</td>
                    <td style={{ fontSize: 12 }}>{p.purchaseDate}</td>
                    <td>{shiftBadge(p.shift)}</td>
                    <td>{p.serialNo}</td>
                    <td>{p.vendorName || p.vendor}</td>
                    <td>{milkBadge(p.milkType)}</td>
                    <td>{fmt(p.qtyLtrs)}</td>
                    <td>{fmt(p.qtyKg)}</td>
                    <td style={{ color: "#d97706", fontWeight: 600 }}>{fmt(p.purchaseFat)}</td>
                    <td style={{ color: "#0284c7", fontWeight: 600 }}>{fmt(p.purchaseSnf)}</td>
                    <td>Ã¢â€šÂ¹{fmt(p.ratePerLtr)}</td>
                    <td>Ã¢â€šÂ¹{fmt(p.ratePerKg)}</td>
                    <td style={{ fontSize: 12 }}>{p.deletedByName || ""}</td>
                    <td style={{ fontSize: 12, whiteSpace: "nowrap" }}>{p.deleted_at?.slice(0, 19) || ""}</td>
                    <td>
                      <button className="btn btn-xs btn-success" style={{ fontSize: 11, padding: "2px 8px" }} onClick={() => doRestore(p.id)}>
                        <i className="fas fa-undo" /> Restore
                      </button>
                    </td>
                  </tr>
                )) : <tr><td colSpan={16}><center style={{ padding: 20, color: "#6c757d" }}>No deleted records found</center></td></tr>}
              </tbody>
            </table>
          </div>
          <Pager cur={dPage} total={dTotalPages} onChange={p => { setDPage(p); loadDeleted(p) }} />
        </>)}

      </>)}



      {/* â•â• BULK PURCHASE SESSION UPDATE MODAL â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â• */}
      <Modal isOpen={bsuOpen} toggle={() => { setBsuOpen(false); resetBsu() }} size="xl" scrollable>
        <ModalHeader toggle={() => { setBsuOpen(false); resetBsu() }}>
          <strong>Bulk Purchase Session Update</strong>{" "}
          <span style={{ color: "#dc3545", fontWeight: 400, fontSize: 13 }}>[* required]</span>
        </ModalHeader>
        <ModalBody style={{ padding: "16px 20px" }}>

          {/* Header: Company(if>1) | Plant | CC | Date | Shift */}
          <div style={{ display: "flex", gap: 14, flexWrap: "wrap", marginBottom: 14 }}>
            {companies.length > 1 && (
              <div style={{ flex: "1 1 150px" }}>
                <label style={{ fontSize: 13, fontWeight: 600 }}>Company *</label>
                <select className="form-control form-control-sm mt-1" value={bsuCompany}
                  onChange={e => onBsuCompany(e.target.value)} style={{ color: "#212529" }}>
                  <option value="">Select</option>
                  {companies.map(c => <option key={c.id} value={c.id}>{c.companyName || c.name}</option>)}
                </select>
              </div>
            )}
            <div style={{ flex: "1 1 180px" }}>
              <label style={{ fontSize: 13, fontWeight: 600 }}>Plant *</label>
              <select className="form-control form-control-sm mt-1" value={bsuPlant}
                onChange={e => onBsuPlant(e.target.value)} style={{ color: "#212529" }}>
                <option value="">Select</option>
                {bsuPlants.map(p => <option key={p.id} value={p.id}>{p.plantName || p.name}</option>)}
              </select>
            </div>
            <div style={{ flex: "1 1 200px" }}>
              <label style={{ fontSize: 13, fontWeight: 600 }}>Chilling Center *</label>
              <select className="form-control form-control-sm mt-1" value={bsuCC}
                onChange={e => onBsuCC(e.target.value)} disabled={!bsuPlant} style={{ color: "#212529" }}>
                <option value="">Select</option>
                {bsuCCs.map(c => <option key={c.id} value={c.id}>{c.chillingCenterName || c.name}</option>)}
              </select>
            </div>
            <div style={{ flex: "1 1 145px" }}>
              <label style={{ fontSize: 13, fontWeight: 600 }}>Date *</label>
              <input type="date" className="form-control form-control-sm mt-1" value={bsuDate}
                onChange={e => { setBsuDate(e.target.value); setBsuPreviewDone(false); setBsuRows([]); setBsuAlert(null) }} />
            </div>
            <div style={{ flex: "0 0 110px" }}>
              <label style={{ fontSize: 13, fontWeight: 600 }}>Shift *</label>
              <div style={{ display: "flex", gap: 12, marginTop: 8 }}>
                <label style={{ fontSize: 13, cursor: "pointer" }}>
                  <input type="radio" name="bsuShift" checked={bsuShift === "0"} onChange={() => { setBsuShift("0"); setBsuPreviewDone(false); setBsuRows([]); setBsuAlert(null) }} style={{ marginRight: 4 }} /> AM
                </label>
                <label style={{ fontSize: 13, cursor: "pointer" }}>
                  <input type="radio" name="bsuShift" checked={bsuShift === "1"} onChange={() => { setBsuShift("1"); setBsuPreviewDone(false); setBsuRows([]); setBsuAlert(null) }} style={{ marginRight: 4 }} /> PM
                </label>
              </div>
            </div>
          </div>

          {/* Preview button */}
          <div style={{ marginBottom: 10 }}>
            <button className="btn btn-primary btn-sm" onClick={handleBsuPreview} disabled={bsuLoading || !bsuCC || !bsuDate || bsuShift === ""}>
              {bsuLoading ? <><i className="fas fa-spinner fa-spin" style={{ marginRight: 5 }} />Loading...</> : "Preview"}
            </button>
          </div>

          {/* Current Row indicator + Row Builder â€” shown after preview */}
          {bsuPreviewDone && (<>
            <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 8, color: "#495057" }}>
              Current Row: <span style={{ color: "#0d6efd" }}>{bsuCurrentRow}</span>
              <span style={{ fontSize: 12, fontWeight: 400, marginLeft: 8, color: "#6c757d" }}>({bsuRows.length} total)</span>
            </div>

            {/* Row Builder Buttons â€” 3 sections matching screenshot */}
            <div style={{ display: "flex", gap: 16, flexWrap: "wrap", marginBottom: 10 }}>
              {/* Reception */}
              <div style={{ flex: "1 1 200px", border: "1px solid #dee2e6", borderRadius: 6, padding: "10px 12px" }}>
                <div style={{ fontSize: 12, fontWeight: 700, color: "#495057", marginBottom: 8 }}>Reception</div>
                <div style={{ display: "flex", gap: 6 }}>
                  <button className="btn btn-primary btn-sm" style={{ flex: 1, fontSize: 12 }}
                    onClick={() => bsuInsertAt(bsuCurrentRow - 1)}>
                    Insert &amp; Shift Down
                  </button>
                  <button className="btn btn-primary btn-sm" style={{ flex: 1, fontSize: 12 }}
                    onClick={() => bsuDeleteAt(bsuCurrentRow - 1)}>
                    Delete &amp; Shift Up
                  </button>
                </div>
              </div>
              {/* Quality */}
              <div style={{ flex: "1 1 200px", border: "1px solid #dee2e6", borderRadius: 6, padding: "10px 12px" }}>
                <div style={{ fontSize: 12, fontWeight: 700, color: "#495057", marginBottom: 8 }}>Quality</div>
                <div style={{ display: "flex", gap: 6 }}>
                  <button className="btn btn-primary btn-sm" style={{ flex: 1, fontSize: 12 }}
                    onClick={() => bsuInsertAt(bsuCurrentRow - 1)}>
                    Insert &amp; Shift Down
                  </button>
                  <button className="btn btn-primary btn-sm" style={{ flex: 1, fontSize: 12 }}
                    onClick={() => bsuDeleteAt(bsuCurrentRow - 1)}>
                    Delete &amp; Shift Up
                  </button>
                </div>
              </div>
              {/* Both */}
              <div style={{ flex: "1 1 260px", border: "1px solid #dee2e6", borderRadius: 6, padding: "10px 12px" }}>
                <div style={{ fontSize: 12, fontWeight: 700, color: "#495057", marginBottom: 8 }}>Both</div>
                <div style={{ display: "flex", gap: 6 }}>
                  <button className="btn btn-primary btn-sm" style={{ flex: 1, fontSize: 12 }}
                    onClick={() => bsuInsertAt(bsuCurrentRow - 1)}>
                    Insert Row
                  </button>
                  <button className="btn btn-primary btn-sm" style={{ flex: 1, fontSize: 12 }}
                    onClick={() => setBsuRows(prev => [...prev, bsuBlankRow()])}>
                    Add Row at Last
                  </button>
                  <button className="btn btn-danger btn-sm" style={{ flex: 1, fontSize: 12 }}
                    onClick={() => bsuDeleteAt(bsuCurrentRow - 1)}>
                    Delete Row
                  </button>
                </div>
              </div>
            </div>
          </>)}

          {/* Alert banner */}
          {bsuAlert && (
            <div style={{
              background: bsuAlert.type === "error" ? "#dc3545" : "#17a2b8",
              color: "#fff", borderRadius: 6, padding: "10px 14px", marginBottom: 10,
              display: "flex", justifyContent: "space-between", alignItems: "flex-start", fontSize: 13
            }}>
              <div>
                <strong><i className="fas fa-exclamation-circle" style={{ marginRight: 6 }} />
                  {bsuAlert.type === "error" ? "Alert!" : "Info"}
                </strong>
                <div style={{ marginTop: 4 }}>{bsuAlert.msg}</div>
              </div>
              <button style={{ background: "none", border: "none", color: "#fff", cursor: "pointer", fontSize: 16 }}
                onClick={() => setBsuAlert(null)}>Ã—</button>
            </div>
          )}

          {/* Save Changes / Close buttons â€” top right (matches screenshot) */}
          {bsuPreviewDone && (
            <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginBottom: 10 }}>
              <button className="btn btn-success btn-sm" onClick={handleBsuSave} disabled={bsuSaving || !bsuRows.length}>
                {bsuSaving ? <><i className="fas fa-spinner fa-spin" style={{ marginRight: 5 }} />Saving...</> : "Save Changes"}
              </button>
              <button className="btn btn-danger btn-sm" onClick={() => { setBsuOpen(false); resetBsu() }}>Close</button>
            </div>
          )}

          {/* Result banner */}
          {bsuResult && (
            <div style={{ background: bsuResult.success ? "#f0fdf4" : "#fef2f2", border: "1px solid " + (bsuResult.success ? "#86efac" : "#fca5a5"), borderRadius: 6, padding: "8px 12px", marginBottom: 10, fontSize: 13 }}>
              <strong>{bsuResult.message}</strong>
              {bsuResult.errors?.length > 0 && (
                <ul style={{ marginTop: 4, marginBottom: 0, paddingLeft: 16 }}>
                  {bsuResult.errors.slice(0, 5).map((e, i) => <li key={i} style={{ color: "#991b1b" }}>{e}</li>)}
                </ul>
              )}
            </div>
          )}

          {/* The spreadsheet table â€” shown after preview */}
          {bsuPreviewDone && (
            <div style={{ overflowX: "auto", border: "1px solid #dee2e6", borderRadius: 6 }}>
              <table className="table table-sm table-bordered mb-0" style={{ fontSize: 12, minWidth: 900 }}>
                <thead style={{ background: "#f8f9fa", position: "sticky", top: 0, zIndex: 1 }}>
                  <tr>
                    <th style={{ width: 30, textAlign: "center", background: "#e9ecef" }}>#</th>
                    <th style={{ minWidth: 80 }}>Route No</th>
                    <th style={{ minWidth: 130 }}>Route Name</th>
                    <th style={{ minWidth: 80 }}>Vendor No</th>
                    <th style={{ minWidth: 130 }}>Vendor Name</th>
                    <th style={{ minWidth: 70 }}>Milk</th>
                    <th style={{ minWidth: 75 }}>Qty</th>
                    <th style={{ minWidth: 65 }}>FAT</th>
                    <th style={{ minWidth: 65 }}>SNF</th>
                  </tr>
                </thead>
                <tbody>
                  {bsuRows.map((row, i) => {
                    const isActive = (i + 1) === bsuCurrentRow
                    const lsColor = s => s === "ok" ? "#28a745" : s === "err" ? "#dc3545" : undefined
                    return (
                      <tr key={i}
                        onClick={() => setBsuCurrentRow(i + 1)}
                        style={{ background: isActive ? "#e8f4ff" : i % 2 === 0 ? "#fff" : "#fafafa", cursor: "pointer" }}>
                        <td style={{ textAlign: "center", verticalAlign: "middle", fontWeight: isActive ? 700 : 400, color: isActive ? "#0d6efd" : "#6c757d" }}>{i + 1}</td>

                        {/* Route No */}
                        <td onClick={e => e.stopPropagation()}>
                          <input className="form-control form-control-sm"
                            value={row.routeNo}
                            onChange={e => setBsuRowField(i, "routeNo", e.target.value)}
                            onBlur={e => bsuLookupRoute(i, e.target.value.trim())}
                            onClick={() => setBsuCurrentRow(i + 1)}
                            style={{ width: 70, borderColor: lsColor(row.routeLookupState) }}
                            placeholder="No." />
                        </td>

                        {/* Route Name â€” auto-filled */}
                        <td style={{ verticalAlign: "middle" }}>
                          <span style={{ fontSize: 12, color: row.routeLookupState === "err" ? "#dc3545" : row.routeLookupState === "ok" ? "#155724" : "#6c757d" }}>
                            {row.routeLookupState === "loading" ? <i className="fas fa-spinner fa-spin" /> : (row.routeName || <span style={{ color: "#adb5bd" }}>auto-fill</span>)}
                          </span>
                        </td>

                        {/* Vendor No */}
                        <td onClick={e => e.stopPropagation()}>
                          <input className="form-control form-control-sm"
                            value={row.vendorNo}
                            onChange={e => setBsuRowField(i, "vendorNo", e.target.value)}
                            onBlur={e => bsuLookupVendor(i, e.target.value.trim())}
                            onClick={() => setBsuCurrentRow(i + 1)}
                            style={{ width: 70, borderColor: lsColor(row.vendorLookupState) }}
                            placeholder="No." />
                        </td>

                        {/* Vendor Name â€” auto-filled */}
                        <td style={{ verticalAlign: "middle" }}>
                          <span style={{ fontSize: 12, color: row.vendorLookupState === "err" ? "#dc3545" : row.vendorLookupState === "ok" ? "#155724" : "#6c757d" }}>
                            {row.vendorLookupState === "loading" ? <i className="fas fa-spinner fa-spin" /> : (row.vendorName || <span style={{ color: "#adb5bd" }}>auto-fill</span>)}
                          </span>
                        </td>

                        {/* Milk Type â€” auto-filled but editable */}
                        <td onClick={e => e.stopPropagation()}>
                          <select className="form-control form-control-sm" value={row.milkType}
                            onChange={e => setBsuRowField(i, "milkType", e.target.value)}
                            style={{ minWidth: 68, color: "#212529" }}>
                            <option value="1">Cow</option>
                            <option value="2">Buffalo</option>
                            <option value="3">Common</option>
                          </select>
                        </td>

                        {/* Qty */}
                        <td onClick={e => e.stopPropagation()}>
                          <input type="number" className="form-control form-control-sm" value={row.qty}
                            onChange={e => setBsuRowField(i, "qty", e.target.value)}
                            step="0.001" style={{ width: 70 }} placeholder="0.000" />
                        </td>

                        {/* FAT */}
                        <td onClick={e => e.stopPropagation()}>
                          <input type="number" className="form-control form-control-sm" value={row.fat}
                            onChange={e => setBsuRowField(i, "fat", e.target.value)}
                            step="0.01" style={{ width: 62 }} placeholder="0.00" />
                        </td>

                        {/* SNF */}
                        <td onClick={e => e.stopPropagation()}>
                          <input type="number" className="form-control form-control-sm" value={row.snf}
                            onChange={e => setBsuRowField(i, "snf", e.target.value)}
                            step="0.01" style={{ width: 62 }} placeholder="0.00" />
                        </td>
                      </tr>
                    )
                  })}
                </tbody>
              </table>
            </div>
          )}
        </ModalBody>
        {!bsuPreviewDone && (
          <ModalFooter>
            <button className="btn btn-danger btn-sm" onClick={() => { setBsuOpen(false); resetBsu() }}>Close</button>
          </ModalFooter>
        )}
      </Modal>

      {/* â•â• BULK PURCHASE UPDATE MODAL â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â• */}
      <Modal isOpen={cuOpen} toggle={() => { setCuOpen(false); resetCu() }} size="xl" scrollable>
        <ModalHeader toggle={() => { setCuOpen(false); resetCu() }}>
          <strong>Bulk Purchase Update</strong> <span style={{ color: "#dc3545", fontWeight: 400, fontSize: 13 }}>[* required]</span>
        </ModalHeader>
        <ModalBody style={{ padding: "18px 22px" }}>
          {/* Row 1: Company(if>1) | Plant | Chilling Center | Route */}
          <div style={{ display: "flex", gap: 14, flexWrap: "wrap", marginBottom: 12 }}>
            {companies.length > 1 && (
              <div style={{ flex: "1 1 150px" }}>
                <label style={{ fontSize: 13, fontWeight: 600 }}>Company *</label>
                <select className="form-control form-control-sm mt-1" value={cuCompany}
                  onChange={e => onCuCompany(e.target.value)} style={{ color: "#212529" }}>
                  <option value="">Select</option>
                  {companies.map(c => <option key={c.id} value={c.id}>{c.companyName || c.name}</option>)}
                </select>
              </div>
            )}
            <div style={{ flex: "1 1 170px" }}>
              <label style={{ fontSize: 13, fontWeight: 600 }}>Plant *</label>
              <select className="form-control form-control-sm mt-1" value={cuPlant}
                onChange={e => onCuPlant(e.target.value)} style={{ color: "#212529" }}>
                <option value="">Select</option>
                {cuPlants.map(p => <option key={p.id} value={p.id}>{p.plantName || p.name}</option>)}
              </select>
            </div>
            <div style={{ flex: "1 1 200px" }}>
              <label style={{ fontSize: 13, fontWeight: 600 }}>Chilling Center *</label>
              <select className="form-control form-control-sm mt-1" value={cuCC}
                onChange={e => onCuCC(e.target.value)} disabled={!cuPlant} style={{ color: "#212529" }}>
                <option value="">Select</option>
                {cuCCs.map(c => <option key={c.id} value={c.id}>{c.chillingCenterName || c.name}</option>)}
              </select>
            </div>
            <div style={{ flex: "1 1 180px" }}>
              <label style={{ fontSize: 13, fontWeight: 600 }}>Route <small style={{ color: "#6c757d" }}>(optional)</small></label>
              <select className="form-control form-control-sm mt-1" value={cuRoute}
                onChange={e => onCuRoute(e.target.value)} disabled={!cuCC} style={{ color: "#212529" }}>
                <option value="">All Routes</option>
                {cuRoutes.map(r => <option key={r.id} value={r.id}>{r.routeName || r.name}</option>)}
              </select>
            </div>
          </div>

          {/* Row 2: Vendor | Display | Date/Shift or Period */}
          <div style={{ display: "flex", gap: 14, flexWrap: "wrap", marginBottom: 12 }}>
            <div style={{ flex: "1 1 180px" }}>
              <label style={{ fontSize: 13, fontWeight: 600 }}>Center/Vendor <small style={{ color: "#6c757d" }}>(optional)</small></label>
              <select className="form-control form-control-sm mt-1" value={cuVendor}
                onChange={e => { setCuVendor(e.target.value); setCuPreviewRows([]); setCuResult(null) }}
                disabled={!cuRoute} style={{ color: "#212529" }}>
                <option value="">All Vendors</option>
                {cuVendors.map(v => <option key={v.id} value={v.id}>{v.vendorName || v.name}</option>)}
              </select>
            </div>
            <div style={{ flex: "1 1 160px" }}>
              <label style={{ fontSize: 13, fontWeight: 600 }}>Display *</label>
              <div style={{ display: "flex", gap: 14, marginTop: 8 }}>
                <label style={{ fontSize: 13, cursor: "pointer" }}>
                  <input type="radio" name="cuDisplay" checked={cuDisplay === "period"} onChange={() => { setCuDisplay("period"); setCuDate(""); setCuShift(""); setCuPreviewRows([]); setCuResult(null) }} style={{ marginRight: 4 }} /> Period
                </label>
                <label style={{ fontSize: 13, cursor: "pointer" }}>
                  <input type="radio" name="cuDisplay" checked={cuDisplay === "single"} onChange={() => { setCuDisplay("single"); setCuPeriodFrom(""); setCuPeriodTo(""); setCuPreviewRows([]); setCuResult(null) }} style={{ marginRight: 4 }} /> Single Shift
                </label>
              </div>
            </div>
            {cuDisplay === "single" ? (<>
              <div style={{ flex: "1 1 145px" }}>
                <label style={{ fontSize: 13, fontWeight: 600 }}>Date *</label>
                <input type="date" className="form-control form-control-sm mt-1" value={cuDate}
                  onChange={e => { setCuDate(e.target.value); setCuPreviewRows([]); setCuResult(null) }} />
              </div>
              <div style={{ flex: "0 0 120px" }}>
                <label style={{ fontSize: 13, fontWeight: 600 }}>Shift *</label>
                <div style={{ display: "flex", gap: 12, marginTop: 8 }}>
                  <label style={{ fontSize: 13, cursor: "pointer" }}><input type="radio" name="cuShift" checked={cuShift === "0"} onChange={() => { setCuShift("0"); setCuPreviewRows([]); setCuResult(null) }} style={{ marginRight: 4 }} /> AM</label>
                  <label style={{ fontSize: 13, cursor: "pointer" }}><input type="radio" name="cuShift" checked={cuShift === "1"} onChange={() => { setCuShift("1"); setCuPreviewRows([]); setCuResult(null) }} style={{ marginRight: 4 }} /> PM</label>
                </div>
              </div>
            </>) : (<>
              <div style={{ flex: "1 1 140px" }}>
                <label style={{ fontSize: 13, fontWeight: 600 }}>From *</label>
                <input type="date" className="form-control form-control-sm mt-1" value={cuPeriodFrom}
                  onChange={e => { setCuPeriodFrom(e.target.value); setCuPreviewRows([]); setCuResult(null) }} />
              </div>
              <div style={{ flex: "1 1 140px" }}>
                <label style={{ fontSize: 13, fontWeight: 600 }}>To *</label>
                <input type="date" className="form-control form-control-sm mt-1" value={cuPeriodTo}
                  onChange={e => { setCuPeriodTo(e.target.value); setCuPreviewRows([]); setCuResult(null) }} />
              </div>
            </>)}
          </div>

          {/* Row 3: Milk Type | Entry Mode | Use Custom Rate Chart | Custom Milk Chart */}
          <div style={{ display: "flex", gap: 14, flexWrap: "wrap", marginBottom: 14 }}>
            <div style={{ flex: "1 1 160px" }}>
              <label style={{ fontSize: 13, fontWeight: 600 }}>Milk Type *</label>
              <div style={{ display: "flex", gap: 12, marginTop: 8 }}>
                {[["0", "Both"], ["1", "Cow"], ["2", "Buffalo"]].map(([v, l]) => (
                  <label key={v} style={{ fontSize: 13, cursor: "pointer" }}>
                    <input type="radio" name="cuMilk" checked={cuMilkType === v} onChange={() => onCuMilkType(v)} style={{ marginRight: 4 }} /> {l}
                  </label>
                ))}
              </div>
            </div>
            <div style={{ flex: "1 1 120px" }}>
              <label style={{ fontSize: 13, fontWeight: 600 }}>Entry Mode</label>
              <div style={{ display: "flex", gap: 12, marginTop: 8 }}>
                {[["SNF", "SNF"], ["CLR", "CLR"]].map(([v, l]) => (
                  <label key={v} style={{ fontSize: 13, cursor: "pointer" }}>
                    <input type="radio" name="cuMode" checked={cuEntryMode === v} onChange={() => setCuEntryMode(v)} style={{ marginRight: 4 }} /> {l}
                  </label>
                ))}
              </div>
            </div>
            <div style={{ flex: "1 1 260px" }}>
              <label style={{ fontSize: 13, fontWeight: 600 }}>Use Custom Rate Chart for Rate Calculation</label>
              <div style={{ display: "flex", gap: 14, marginTop: 8 }}>
                <label style={{ fontSize: 13, cursor: "pointer" }}><input type="radio" name="cuCustomRate" checked={cuUseCustomRate === "Yes"} onChange={() => onCuUseCustomRate("Yes")} style={{ marginRight: 4 }} /> Yes</label>
                <label style={{ fontSize: 13, cursor: "pointer" }}><input type="radio" name="cuCustomRate" checked={cuUseCustomRate === "No"} onChange={() => onCuUseCustomRate("No")} style={{ marginRight: 4 }} /> No</label>
              </div>
            </div>
            {cuUseCustomRate === "Yes" && (
              <div style={{ flex: "1 1 220px" }}>
                <label style={{ fontSize: 13, fontWeight: 600 }}>{cuChartLabel}</label>
                <select className="form-control form-control-sm mt-1" value={cuRateChartId}
                  onChange={e => { setCuRateChartId(e.target.value); setCuPreviewRows([]); setCuResult(null) }}>
                  <option value="">Choose a common rate chart . . .</option>
                  {cuRateCharts.map(rc => (
                    <option key={rc.id} value={rc.id}>{rc.ratechartName || `Rate Chart #${rc.id}`}</option>
                  ))}
                </select>
              </div>
            )}
          </div>

          {/* Row 4: Apply Custom Incentive | Incentive Chart | Flat Incentive */}
          <div style={{ display: "flex", gap: 14, flexWrap: "wrap", marginBottom: 14 }}>
            <div style={{ flex: "1 1 280px" }}>
              <label style={{ fontSize: 13, fontWeight: 600 }}>Apply Custom Incentive</label>
              <div style={{ display: "flex", gap: 14, marginTop: 8 }}>
                <label style={{ fontSize: 13, cursor: "pointer" }}><input type="radio" name="cuInc" checked={cuApplyInc === "No"} onChange={() => { setCuApplyInc("No"); setCuFlatInc(""); setCuIncentiveChartId(""); setCuPreviewRows([]); setCuResult(null) }} style={{ marginRight: 4 }} /> No</label>
                <label style={{ fontSize: 13, cursor: "pointer" }}><input type="radio" name="cuInc" checked={cuApplyInc === "chart"} onChange={() => { setCuApplyInc("chart"); setCuFlatInc(""); setCuPreviewRows([]); setCuResult(null) }} style={{ marginRight: 4 }} /> Incentive Chart Based</label>
                <label style={{ fontSize: 13, cursor: "pointer" }}><input type="radio" name="cuInc" checked={cuApplyInc === "flat"} onChange={() => { setCuApplyInc("flat"); setCuIncentiveChartId(""); setCuPreviewRows([]); setCuResult(null) }} style={{ marginRight: 4 }} /> Flat Incentive</label>
              </div>
            </div>
            {cuApplyInc === "chart" && (
              <div style={{ flex: "1 1 220px" }}>
                <label style={{ fontSize: 13, fontWeight: 600 }}>Custom Incentive Chart *</label>
                <select className="form-control form-control-sm mt-1" value={cuIncentiveChartId}
                  onChange={e => { setCuIncentiveChartId(e.target.value); setCuPreviewRows([]); setCuResult(null) }}>
                  <option value="">Select incentive chart . . .</option>
                  {cuIncentiveCharts.map(ic => (
                    <option key={ic.id} value={ic.id}>{ic.chartName || `Incentive Chart #${ic.id}`}</option>
                  ))}
                </select>
              </div>
            )}
            {cuApplyInc === "flat" && (
              <div style={{ flex: "1 1 180px" }}>
                <label style={{ fontSize: 13, fontWeight: 600 }}>Flat Incentive / Liter *</label>
                <input type="number" min="0" step="0.01" className="form-control form-control-sm mt-1"
                  placeholder="e.g. 0.50" value={cuFlatInc}
                  onChange={e => { setCuFlatInc(e.target.value); setCuPreviewRows([]); setCuResult(null) }} />
              </div>
            )}
          </div>

          {/* Loading */}
          {cuLoading && <div style={{ textAlign: "center", padding: 24, color: "#6c757d" }}><i className="fas fa-spinner fa-spin" style={{ fontSize: 20 }} />&nbsp;Loading previewâ€¦</div>}

          {/* Manipulate Values + Summary + Table â€” shown after Preview */}
          {!cuLoading && cuPreviewRows.length > 0 && (() => {
            const oldSt = cuOldSummary(cuOrigRows)
            const newSt = cuNewSummary(cuPreviewRows)
            const hasDiff = (a, b) => Math.abs(parseFloat(a || 0) - parseFloat(b || 0)) > 0.0001
            const newCell = (nv, ov) => ({ background: "#fff59d", color: hasDiff(nv, ov) ? (nv > ov ? "#16a34a" : "#dc2626") : "#212529", fontWeight: hasDiff(nv, ov) ? 700 : 400 })
            return (
              <div>
                <div style={{ fontWeight: 700, fontSize: 15, marginBottom: 8 }}>Manipulate Values</div>
                <div style={{ display: "flex", alignItems: "center", gap: 6, flexWrap: "wrap", background: "#f8f9fa", border: "1px solid #dee2e6", borderRadius: 6, padding: "8px 12px", marginBottom: 10 }}>
                  <select className="form-control form-control-sm" style={{ width: 105 }} value={cuOvAction} onChange={e => setCuOvAction(e.target.value)}>
                    <option value="increase">Increase</option><option value="decrease">Decrease</option>
                  </select>
                  <select className="form-control form-control-sm" style={{ width: 135 }} value={cuOvField} onChange={e => setCuOvField(e.target.value)}>
                    <option value="qty">Total Quantity</option><option value="fat">FAT</option>
                    <option value="snf">SNF</option><option value="clr">CLR</option><option value="rate">Rate / Ltr</option>
                  </select>
                  <span style={{ fontSize: 13, color: "#495057", fontWeight: 500 }}>By</span>
                  <input type="number" step="0.001" className="form-control form-control-sm" style={{ width: 80 }} value={cuOvBy} onChange={e => setCuOvBy(e.target.value)} placeholder="Value" />
                  <span style={{ fontSize: 13, color: "#495057", fontWeight: 500 }}>when</span>
                  <select className="form-control form-control-sm" style={{ width: 110 }} value={cuOvCondField} onChange={e => setCuOvCondField(e.target.value)}>
                    <option value="qty">Quantity</option><option value="fat">FAT</option>
                    <option value="snf">SNF</option><option value="clr">CLR</option><option value="rate">Rate</option>
                  </select>
                  <span style={{ fontSize: 13, color: "#495057", fontWeight: 500 }}>between</span>
                  <input type="number" step="0.001" placeholder="Min" className="form-control form-control-sm" style={{ width: 72 }} value={cuOvCondMin} onChange={e => setCuOvCondMin(e.target.value)} />
                  <span style={{ fontSize: 13, color: "#495057", fontWeight: 500 }}>and</span>
                  <input type="number" step="0.001" placeholder="Max" className="form-control form-control-sm" style={{ width: 72 }} value={cuOvCondMax} onChange={e => setCuOvCondMax(e.target.value)} />
                  <button className="btn btn-primary btn-sm" onClick={cuApplyManipulate} style={{ fontWeight: 600, minWidth: 95 }}>Manipulate</button>
                  <button className="btn btn-outline-secondary btn-sm" title="Reset to original values" onClick={() => setCuPreviewRows(cuOrigRows.map(r => ({ ...r })))}><i className="fas fa-undo" /></button>
                </div>
                <div style={{ fontSize: 13, marginBottom: 8 }}>
                  <div style={{ color: "#6c757d", marginBottom: 3 }}>
                    <b style={{ display: "inline-block", minWidth: 100 }}>Old Summary</b>
                    &nbsp;Total Quantity : <b>{oldSt.qty}</b>&nbsp;&nbsp;Avg FAT : <b>{oldSt.fat}</b>&nbsp;&nbsp;Avg SNF : <b>{oldSt.snf}</b>&nbsp;&nbsp;Avg Rate : <b>{oldSt.rate}</b>&nbsp;&nbsp;Amount : <b>{oldSt.amount}</b>
                  </div>
                  <div style={{ color: "#0d6efd", marginBottom: 3 }}>
                    <b style={{ display: "inline-block", minWidth: 100 }}>New Summary</b>
                    &nbsp;Total Quantity : <b>{newSt.qty}</b>&nbsp;&nbsp;Avg FAT : <b>{newSt.fat}</b>&nbsp;&nbsp;Avg SNF : <b>{newSt.snf}</b>&nbsp;&nbsp;Avg Rate : <b>{newSt.rate}</b>&nbsp;&nbsp;Amount : <b>{newSt.amount}</b>
                  </div>
                  <div><b>Total Entries : {cuPreviewRows.length}</b>
                    {cuTotal > 300 && <span style={{ color: "#d97706", marginLeft: 10, fontSize: 12 }}>(showing first 300 â€” all {cuTotal} will be updated on save)</span>}
                  </div>
                </div>
                <div style={{ maxHeight: 300, overflowY: "auto", overflowX: "auto", border: "1px solid #dee2e6", borderRadius: 6 }}>
                  <table className="table table-sm table-bordered mb-0" style={{ fontSize: 11, minWidth: 1200 }}>
                    <thead style={{ background: "#f8f9fa", position: "sticky", top: 0, zIndex: 1 }}>
                      <tr>
                        <th style={{ width: 30, textAlign: "center" }}>#</th>
                        <th style={{ minWidth: 110 }}>Route</th><th style={{ minWidth: 120 }}>Member</th>
                        <th style={{ minWidth: 85 }}>Date</th><th style={{ width: 42 }}>Shift</th><th style={{ width: 46 }}>Milk</th>
                        <th>Old Qty</th><th style={{ background: "#fff59d" }}>New Qty</th>
                        <th>Old FAT</th><th style={{ background: "#fff59d" }}>New FAT</th>
                        <th>Old SNF</th><th style={{ background: "#fff59d" }}>New SNF</th>
                        <th>Old Rate</th><th style={{ background: "#fff59d" }}>New Rate</th>
                        <th>Old Inc</th><th style={{ background: "#fff59d" }}>New Inc</th>
                        <th>Old Amt</th><th style={{ background: "#fff59d" }}>New Amt</th>
                      </tr>
                    </thead>
                    <tbody>
                      {cuPreviewRows.map((r, i) => {
                        const o = cuOrigRows[i] || r
                        const oQty = parseFloat(o.qtyLtrs || 0), nQty = parseFloat(r.qtyLtrs || 0)
                        const oFat = parseFloat(o.purchaseFat || 0), nFat = parseFloat(r.purchaseFat || 0)
                        const oSnf = parseFloat(o.purchaseSnf || o.purchaseClr || 0), nSnf = parseFloat(r.purchaseSnf || r.purchaseClr || 0)
                        const oRate = parseFloat(o.oldRatePerLtr || 0), nRate = parseFloat(r.newRatePerLtr || 0)
                        const oInc = parseFloat(o.oldIncentive || 0), nInc = parseFloat(r.newIncentive || 0)
                        const oAmt = parseFloat((oRate * oQty + oInc).toFixed(2)), nAmt = parseFloat(r.newTotal || 0)
                        return (
                          <tr key={r.id} style={{ background: i % 2 === 0 ? "#fff" : "#fafafa" }}>
                            <td style={{ textAlign: "center", verticalAlign: "middle" }}>{i + 1}</td>
                            <td style={{ whiteSpace: "nowrap", verticalAlign: "middle" }}>{r.routeName || "-"}</td>
                            <td style={{ whiteSpace: "nowrap", verticalAlign: "middle" }}>{r.vendorName || "-"}</td>
                            <td style={{ whiteSpace: "nowrap", verticalAlign: "middle" }}>{r.purchaseDate}</td>
                            <td style={{ verticalAlign: "middle" }}>{r.shift == 0 ? "AM" : "PM"}</td>
                            <td style={{ verticalAlign: "middle" }}>{r.milkType == 1 ? "Cow" : r.milkType == 2 ? "Buf" : "Cmn"}</td>
                            <td style={{ verticalAlign: "middle" }}>{oQty}</td>
                            <td style={{ ...newCell(nQty, oQty), verticalAlign: "middle" }}>{nQty}</td>
                            <td style={{ verticalAlign: "middle" }}>{oFat}</td>
                            <td style={{ ...newCell(nFat, oFat), verticalAlign: "middle" }}>{nFat}</td>
                            <td style={{ verticalAlign: "middle" }}>{oSnf}</td>
                            <td style={{ ...newCell(nSnf, oSnf), verticalAlign: "middle" }}>{nSnf}</td>
                            <td style={{ verticalAlign: "middle" }}>Rs.{oRate}</td>
                            <td style={{ ...newCell(nRate, oRate), verticalAlign: "middle" }}>Rs.{nRate}</td>
                            <td style={{ verticalAlign: "middle" }}>Rs.{oInc}</td>
                            <td style={{ ...newCell(nInc, oInc), verticalAlign: "middle" }}>Rs.{nInc}</td>
                            <td style={{ verticalAlign: "middle" }}>Rs.{oAmt.toFixed(2)}</td>
                            <td style={{ ...newCell(nAmt, oAmt), verticalAlign: "middle" }}>Rs.{nAmt.toFixed(2)}</td>
                          </tr>
                        )
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            )
          })()}

          {/* Result banner */}
          {cuResult && (
            <div style={{ background: cuResult.success ? "#f0fdf4" : "#fef2f2", border: "1px solid " + (cuResult.success ? "#86efac" : "#fca5a5"), borderRadius: 6, padding: "10px 14px", marginTop: 12, fontSize: 13 }}>
              <strong>{cuResult.message}</strong>
              {cuResult.errors?.length > 0 && (
                <ul style={{ marginTop: 6, marginBottom: 0, paddingLeft: 18 }}>
                  {cuResult.errors.slice(0, 10).map((e, i) => <li key={i} style={{ color: "#991b1b" }}>{e}</li>)}
                  {cuResult.errors.length > 10 && <li>â€¦and {cuResult.errors.length - 10} more</li>}
                </ul>
              )}
            </div>
          )}
        </ModalBody>
        <ModalFooter>
          <button className="btn btn-primary btn-sm" onClick={handleCuPreview} disabled={cuLoading || !cuCC}>
            {cuLoading ? <><i className="fas fa-spinner fa-spin" style={{ marginRight: 5 }} />Loading...</> : <><i className="fas fa-search" style={{ marginRight: 5 }} />Preview</>}
          </button>
          <button className="btn btn-success btn-sm" onClick={handleCuSave} disabled={cuSaving || cuPreviewRows.length === 0}>
            {cuSaving ? <><i className="fas fa-spinner fa-spin" style={{ marginRight: 5 }} />Saving...</> : <><i className="fas fa-save" style={{ marginRight: 5 }} />Save Changes</>}
          </button>
          <button className="btn btn-danger btn-sm" onClick={() => { setCuOpen(false); resetCu() }}>Close</button>
        </ModalFooter>
      </Modal>

      {/* â•â• BULK PURCHASE ENTRY MODAL â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â• */}
      <Modal isOpen={bpOpen} toggle={() => setBpOpen(false)} size="xl" scrollable>
        <ModalHeader toggle={() => setBpOpen(false)}>
          <strong>Bulk Purchase Entry</strong> <small className="text-muted">[* required]</small>
        </ModalHeader>
        <ModalBody>
          {/* â”€â”€ Row 1: Company (if >1) â†’ Plant â†’ CC â†’ Date â†’ Shift â”€â”€ */}
          <div style={{ display: "flex", gap: 12, flexWrap: "wrap", marginBottom: 14 }}>
            {companies.length > 1 && (
              <div style={{ flex: "1 1 150px" }}>
                <label style={{ fontSize: 12, fontWeight: 600 }}>Company</label>
                <select className="form-control form-control-sm" value={bpCompany}
                  onChange={e => onBpCompany(e.target.value)} style={{ color: "#212529" }}>
                  <option value="">Select</option>
                  {companies.map(c => <option key={c.id} value={c.id}>{c.companyName || c.name}</option>)}
                </select>
              </div>
            )}
            <div style={{ flex: "1 1 180px" }}>
              <label style={{ fontSize: 12, fontWeight: 600 }}>Plant <span style={{ color: "red" }}>*</span></label>
              <select className="form-control form-control-sm" value={bpPlant}
                onChange={e => onBpPlant(e.target.value)} style={{ color: "#212529" }}>
                <option value="">Select</option>
                {bpPlants.map(p => <option key={p.id} value={p.id}>{p.plantName || p.name}</option>)}
              </select>
            </div>
            <div style={{ flex: "1 1 200px" }}>
              <label style={{ fontSize: 12, fontWeight: 600 }}>Chilling Center <span style={{ color: "red" }}>*</span></label>
              <select className="form-control form-control-sm" value={bpCC}
                onChange={e => onBpCC(e.target.value)} disabled={!bpPlant} style={{ color: "#212529" }}>
                <option value="">Select</option>
                {bpCCs.map(c => <option key={c.id} value={c.id}>{c.chillingCenterName || c.name}</option>)}
              </select>
            </div>
            <div style={{ flex: "1 1 145px" }}>
              <label style={{ fontSize: 12, fontWeight: 600 }}>Date <span style={{ color: "red" }}>*</span></label>
              <input type="date" className="form-control form-control-sm" value={bpDate}
                onChange={e => setBpDate(e.target.value)} />
            </div>
            <div style={{ flex: "0 0 120px" }}>
              <label style={{ fontSize: 12, fontWeight: 600 }}>Shift <span style={{ color: "red" }}>*</span></label>
              <div style={{ paddingTop: 6 }}>
                <label style={{ marginRight: 12, cursor: "pointer" }}>
                  <input type="radio" name="bpShift" value="0" checked={bpShift === "0"} onChange={() => setBpShift("0")} /> AM
                </label>
                <label style={{ cursor: "pointer" }}>
                  <input type="radio" name="bpShift" value="1" checked={bpShift === "1"} onChange={() => setBpShift("1")} /> PM
                </label>
              </div>
            </div>
          </div>

          {/* â”€â”€ Entry Mode â”€â”€ */}
          <div style={{ marginBottom: 12 }}>
            <span style={{ fontSize: 12, fontWeight: 600, marginRight: 10 }}>Entry Mode</span>
            <label style={{ marginRight: 14, cursor: "pointer", fontSize: 13 }}>
              <input type="radio" name="bpMode" value="SNF" checked={bpMode === "SNF"} onChange={() => setBpMode("SNF")} /> SNF
            </label>
            <label style={{ cursor: "pointer", fontSize: 13 }}>
              <input type="radio" name="bpMode" value="CLR" checked={bpMode === "CLR"} onChange={() => setBpMode("CLR")} /> CLR
            </label>
          </div>

          {/* â”€â”€ Info Banner â”€â”€ */}
          <div style={{
            background: "#17a2b8", color: "#fff", borderRadius: 4,
            padding: "8px 14px", marginBottom: 12, fontSize: 13,
            display: "flex", justifyContent: "space-between", alignItems: "center"
          }}>
            <div>
              <strong>Incoming Unit:KG &nbsp; Purchase CM Unit:Liters &nbsp; Purchase BM Unit:Liters</strong><br />
              <small>Conversion will be done for Both Milk Types</small>
            </div>
            {bpCC && <span style={{ opacity: 0.85, fontSize: 12 }}>{bpRows.length} row(s)</span>}
          </div>

          {/* â”€â”€ Add New Button (gated on required fields) â”€â”€ */}
          <div style={{ marginBottom: 10 }}>
            <button className="btn btn-primary btn-sm"
              disabled={!bpPlant || !bpCC || !bpDate}
              onClick={() => { setBpShowTable(true); setBpRows(r => [...r, defaultBpRow()]) }}
              style={{ minWidth: 90 }}>
              <i className="fas fa-plus" style={{ marginRight: 5 }} /> Add New
            </button>
            {(!bpPlant || !bpCC || !bpDate) && (
              <small style={{ marginLeft: 10, color: "#6c757d" }}>Fill all required fields to add rows</small>
            )}
          </div>

          {/* â”€â”€ Rows Table (only visible after Add New clicked) â”€â”€ */}
          {bpShowTable && bpRows.length > 0 && (
            <div className="table-responsive">
              <table className="table table-sm table-bordered" style={{ fontSize: 12, minWidth: 820 }}>
                <thead style={{ background: "#e9ecef" }}>
                  <tr>
                    <th style={{ width: 28, textAlign: "center" }}>#</th>
                    <th style={{ minWidth: 70 }}>Route No</th>
                    <th style={{ minWidth: 130 }}>Route Name</th>
                    <th style={{ minWidth: 70 }}>Vendor No</th>
                    <th style={{ minWidth: 140 }}>Vendor Name</th>
                    <th style={{ minWidth: 80 }}>Milk</th>
                    <th style={{ minWidth: 75 }}>Qty Ltrs</th>
                    <th style={{ minWidth: 65 }}>FAT *</th>
                    {bpMode === "SNF" ? <th style={{ minWidth: 65 }}>SNF</th> : <th style={{ minWidth: 65 }}>CLR</th>}
                    <th style={{ width: 32 }}></th>
                  </tr>
                </thead>
                <tbody>
                  {bpRows.map((row, i) => (
                    <tr key={i}>
                      <td style={{ textAlign: "center", verticalAlign: "middle", color: "#6c757d" }}>{i + 1}</td>

                      {/* Route No */}
                      <td>
                        <input className="form-control form-control-sm"
                          value={row.routeNo}
                          onChange={e => setBpRowField(i, "routeNo", e.target.value)}
                          onBlur={e => lookupRoute(i, e.target.value.trim())}
                          style={{ width: 68, borderColor: row.routeLookupState === "err" ? "#dc3545" : row.routeLookupState === "ok" ? "#28a745" : undefined }}
                          placeholder="No."
                        />
                      </td>

                      {/* Route Name (auto-filled) */}
                      <td>
                        <div style={{
                          minWidth: 120, padding: "3px 6px", background: "#f8f9fa", borderRadius: 3,
                          color: row.routeLookupState === "err" ? "#dc3545" : row.routeLookupState === "ok" ? "#155724" : "#6c757d",
                          fontSize: 12, minHeight: 28, display: "flex", alignItems: "center"
                        }}>
                          {row.routeLookupState === "loading" ? <i className="fas fa-spinner fa-spin" /> :
                            row.routeName || <span style={{ color: "#adb5bd" }}>auto-fill</span>}
                        </div>
                      </td>

                      {/* Vendor No */}
                      <td>
                        <input className="form-control form-control-sm"
                          value={row.vendorNo}
                          onChange={e => setBpRowField(i, "vendorNo", e.target.value)}
                          onBlur={e => lookupVendor(i, e.target.value.trim())}
                          style={{ width: 68, borderColor: row.vendorLookupState === "err" ? "#dc3545" : row.vendorLookupState === "ok" ? "#28a745" : undefined }}
                          placeholder="No."
                        />
                      </td>

                      {/* Vendor Name (auto-filled) */}
                      <td>
                        <div style={{
                          minWidth: 120, padding: "3px 6px", background: "#f8f9fa", borderRadius: 3,
                          color: row.vendorLookupState === "err" ? "#dc3545" : row.vendorLookupState === "ok" ? "#155724" : "#6c757d",
                          fontSize: 12, minHeight: 28, display: "flex", alignItems: "center"
                        }}>
                          {row.vendorLookupState === "loading" ? <i className="fas fa-spinner fa-spin" /> :
                            row.vendorName || <span style={{ color: "#adb5bd" }}>auto-fill</span>}
                        </div>
                      </td>

                      {/* Milk Type */}
                      <td>
                        <select className="form-control form-control-sm" value={row.milkType}
                          onChange={e => setBpRowField(i, "milkType", e.target.value)}
                          style={{ minWidth: 78, color: "#212529" }}>
                          <option value="1">Cow</option>
                          <option value="2">Buffalo</option>
                          <option value="3">Common</option>
                        </select>
                      </td>

                      {/* Qty */}
                      <td>
                        <input type="number" className="form-control form-control-sm" value={row.qty}
                          onChange={e => setBpRowField(i, "qty", e.target.value)}
                          step="0.01" style={{ width: 75 }} placeholder="0.00" />
                      </td>

                      {/* FAT */}
                      <td>
                        <input type="number" className="form-control form-control-sm" value={row.purchaseFat}
                          onChange={e => setBpRowField(i, "purchaseFat", e.target.value)}
                          step="0.01" style={{ width: 64, borderColor: !row.purchaseFat ? "#dc3545" : undefined }}
                          placeholder="*" />
                      </td>

                      {/* SNF or CLR */}
                      {bpMode === "SNF"
                        ? <td><input type="number" className="form-control form-control-sm" value={row.purchaseSnf}
                          onChange={e => setBpRowField(i, "purchaseSnf", e.target.value)}
                          step="0.01" style={{ width: 64 }} placeholder="0.00" /></td>
                        : <td><input type="number" className="form-control form-control-sm" value={row.purchaseClr}
                          onChange={e => setBpRowField(i, "purchaseClr", e.target.value)}
                          step="0.01" style={{ width: 64 }} placeholder="0.00" /></td>
                      }

                      {/* Remove row */}
                      <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                        <button className="btn btn-sm btn-outline-danger" style={{ padding: "1px 6px" }}
                          onClick={() => setBpRows(r => r.filter((_, idx) => idx !== i))}>
                          <i className="fa fa-times" />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </ModalBody>
        <ModalFooter>
          <button className="btn btn-success" onClick={saveBp} disabled={bpSaving || !bpShowTable}>
            {bpSaving ? <><i className="fas fa-spinner fa-spin" style={{ marginRight: 5 }} />Saving...</> : "Save Changes"}
          </button>
          <button className="btn btn-danger" onClick={() => setBpOpen(false)}>Close</button>
        </ModalFooter>
      </Modal>

      {/* Ã¢â€â‚¬Ã¢â€â‚¬ SWEET ALERTS Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬ */}
      {confirmDel && <SweetAlert title="Are you sure?" warning showCancel confirmBtnBsStyle="success" cancelBtnBsStyle="danger"
        onConfirm={() => { doDelete(); setConfirmDel(false); setSuccessDlg(true) }} onCancel={() => setConfirmDel(false)}>You won't be able to revert this!</SweetAlert>}
      {successDlg && <SweetAlert success title="Deleted!" onConfirm={() => setSuccessDlg(false)}>Purchase deleted.</SweetAlert>}
      {bulkConfirm && <SweetAlert title={`Delete ${selected.length} record(s)?`} warning showCancel confirmBtnBsStyle="success" cancelBtnBsStyle="danger"
        onConfirm={() => { doBulkDelete(); setBulkConfirm(false) }} onCancel={() => setBulkConfirm(false)}>This cannot be undone.</SweetAlert>}


    {/* == BULK SMS MODAL ================================================ */}
    <Modal isOpen={csOpen} toggle={() => { setCsOpen(false); resetCs() }} size="xl">
      <ModalHeader toggle={() => { setCsOpen(false); resetCs() }}>
        Send Bulk Purchase SMS <span style={{color:"#dc3545",fontWeight:400,fontSize:13}}>[* required]</span>
      </ModalHeader>
      <ModalBody style={{padding:"18px 22px"}}>
        <div style={{display:"flex",gap:14,flexWrap:"wrap",marginBottom:14}}>
          {companies.length > 1 && (
            <div style={{flex:"1 1 200px"}}><label style={{fontSize:13,fontWeight:600}}>Company *</label>
              <select className="form-control form-control-sm mt-1" onChange={e => onCsCompanyChange(e.target.value)}>
                <option value="">-- Select Company --</option>
                {companies.map(c => <option key={c.id} value={c.id}>{c.companyName||c.name}</option>)}
              </select></div>
          )}
          <div style={{flex:"1 1 200px"}}><label style={{fontSize:13,fontWeight:600}}>Plant *</label>
            <select className="form-control form-control-sm mt-1" value={csPlant} onChange={e => onCsPlant(e.target.value)}>
              <option value="">-- Select Plant --</option>
              {csPlants.map(p => <option key={p.id} value={p.id}>{p.plantName||p.name}</option>)}
            </select></div>
          <div style={{flex:"1 1 200px"}}><label style={{fontSize:13,fontWeight:600}}>Chilling Center *</label>
            <select className="form-control form-control-sm mt-1" value={csCC} disabled={!csPlant} onChange={e => onCsCC(e.target.value)}>
              <option value="">-- Select CC --</option>
              {csCCs.map(c => <option key={c.id} value={c.id}>{c.chillingCenterName||c.name}</option>)}
            </select></div>
          <div style={{flex:"1 1 200px"}}><label style={{fontSize:13,fontWeight:600}}>Route</label>
            <select className="form-control form-control-sm mt-1" value={csRoute} disabled={!csCC} onChange={e => onCsRoute(e.target.value)}>
              <option value="">All Routes</option>
              {csRoutes.map(r => <option key={r.id} value={r.id}>{r.routeName||r.name}</option>)}
            </select></div>
          <div style={{flex:"1 1 140px"}}><label style={{fontSize:13,fontWeight:600}}>Date *</label>
            <input type="date" className="form-control form-control-sm mt-1" value={csDate} onChange={e => setCsDate(e.target.value)}/></div>
          <div style={{flex:"1 1 120px"}}><label style={{fontSize:13,fontWeight:600}}>Shift *</label>
            <div style={{display:"flex",gap:14,marginTop:6}}>
              <label style={{fontSize:13}}><input type="radio" name="csShft" checked={csShift==="0"} onChange={() => setCsShift("0")} style={{marginRight:4}}/>AM</label>
              <label style={{fontSize:13}}><input type="radio" name="csShft" checked={csShift==="1"} onChange={() => setCsShift("1")} style={{marginRight:4}}/>PM</label>
            </div></div>
          <div style={{flex:"0 0 auto",alignSelf:"flex-end",paddingBottom:2}}>
            <label style={{fontSize:13,display:"block",marginBottom:4}}>
              <input type="checkbox" checked={csIgnore} onChange={e => setCsIgnore(e.target.checked)} style={{marginRight:4}}/>Ignore Already Sent</label>
            <button className="btn btn-primary btn-sm" onClick={handleCsPreview} disabled={csLoading || !csCC || !csDate || csShift===""}>
              {csLoading ? "Loading..." : "Preview"}</button></div>
        </div>
        {csPreviewMeta && (
          <div style={{background:"#eff6ff",border:"1px solid #bfdbfe",borderRadius:6,padding:"8px 14px",marginBottom:12,fontSize:13,display:"flex",gap:16,flexWrap:"wrap",alignItems:"center"}}>
            <span><strong>{csPreviewMeta.total}</strong> records found</span>
            <span style={{color:"#16a34a",fontWeight:600}}>Will Send: <strong>{csPreviewMeta.willSend}</strong></span>
            {csPreviewMeta.noMobile > 0 && <span style={{color:"#d97706"}}>No Mobile: <strong>{csPreviewMeta.noMobile}</strong></span>}
            {csPreviewMeta.alreadySent > 0 && <span style={{color:"#6c757d"}}>Already Sent: <strong>{csPreviewMeta.alreadySent}</strong></span>}
          </div>
        )}
        {csResult && (
          <div style={{background:csResult.success?"#f0fdf4":"#fef2f2",border:"1px solid "+(csResult.success?"#86efac":"#fca5a5"),borderRadius:6,padding:"10px 14px",marginBottom:12,fontSize:13}}>
            <strong>{csResult.message}</strong>
          </div>
        )}
        {!csLoading && csPreviewRows.length > 0 && (
          <div style={{maxHeight:300,overflowY:"auto",border:"1px solid #dee2e6",borderRadius:6,marginBottom:14}}>
            <table className="table table-sm table-bordered mb-0" style={{fontSize:12}}>
              <thead style={{background:"#f8f9fa",position:"sticky",top:0,zIndex:1}}>
                <tr><th style={{width:30}}>#</th><th>Vendor#</th><th style={{minWidth:140}}>Vendor Name</th><th style={{minWidth:110}}>Mobile</th><th>Qty(L)</th><th>FAT</th><th>SNF</th><th>Amount</th><th style={{minWidth:100}}>Status</th></tr>
              </thead>
              <tbody>
                {csPreviewRows.map((r,i) => (
                  <tr key={i} style={{background:i%2===0?"#fff":"#fafafa"}}>
                    <td style={{textAlign:"center"}}>{i+1}</td>
                    <td><strong>{r.vendorNumber||r.producerNum||"-"}</strong></td>
                    <td>{r.vendorName||r.producerName||"-"}</td>
                    <td style={{fontFamily:"monospace",fontSize:11}}>{r.hasMobile ? r.mobile : <span style={{color:"#dc3545"}}>No Mobile</span>}</td>
                    <td>{r.qtyLtrs}</td><td>{r.fat||r.purchaseFat}</td><td>{r.snf||r.purchaseSnf}</td>
                    <td>Rs.{(parseFloat(r.amount||r.netAmount||0)).toFixed(2)}</td>
                    <td>{r.willSend ? <span style={{color:"#16a34a",fontWeight:600}}>Will Send</span> : r.alreadySent ? <span style={{color:"#6c757d"}}>Already Sent</span> : <span style={{color:"#dc3545"}}>No Mobile</span>}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
        <div style={{display:"flex",justifyContent:"flex-end",gap:8}}>
          <button className="btn btn-success btn-sm" onClick={handleCsSend} disabled={csSending || !csPreviewMeta || csPreviewMeta.willSend===0}>
            {csSending ? "Sending..." : "Send SMS"}</button>
          <button className="btn btn-danger btn-sm" onClick={() => { setCsOpen(false); resetCs() }}>Close</button>
        </div>
      </ModalBody>
    </Modal>
    {/* â•â• EXCEL IMPORT SINGLE SHIFT MODAL â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â• */}
    <Modal isOpen={exSOpen} toggle={() => setExSOpen(false)} size="lg">
      <ModalHeader toggle={() => setExSOpen(false)}>Bulk Purchase Excel Import <span style={{color:"#dc3545",fontWeight:400,fontSize:13}}>[* required]</span></ModalHeader>
      <ModalBody>
        <div style={{display:"flex",gap:12,flexWrap:"wrap",marginBottom:14}}>
          {companies.length > 1 && (<div style={{flex:"1 1 170px"}}><label style={{fontSize:12,fontWeight:600}}>Company *</label><select className="form-control form-control-sm" onChange={e=>{setExSPlant("");setExSCC("");setExSPlants([]);setExSCCs([]);if(e.target.value)api.get("plants-by-company/"+e.target.value).then(r=>setExSPlants(arr(r))).catch(()=>{});else api.get("plants").then(r=>setExSPlants(arr(r))).catch(()=>{})}}><option value="">-- Select Company --</option>{companies.map(c=><option key={c.id} value={c.id}>{c.companyName||c.name}</option>)}</select></div>)}
          <div style={{flex:"1 1 170px"}}><label style={{fontSize:12,fontWeight:600}}>Plant *</label>
            <select className="form-control form-control-sm" value={exSPlant} onChange={e=>{setExSPlant(e.target.value);setExSCC("");setExSCCs([]);if(e.target.value)api.get("chillings-by-plant/"+e.target.value).then(r=>setExSCCs(arr(r))).catch(()=>{})}}><option value="">Select</option>{exSPlants.map(p=><option key={p.id} value={p.id}>{p.plantName||p.name}</option>)}</select></div>
          <div style={{flex:"1 1 200px"}}><label style={{fontSize:12,fontWeight:600}}>Chilling Center *</label>
            <select className="form-control form-control-sm" value={exSCC} onChange={e=>setExSCC(e.target.value)} disabled={!exSPlant}><option value="">Select</option>{exSCCs.map(c=><option key={c.id} value={c.id}>{c.chillingCenterName||c.name}</option>)}</select></div>
          <div style={{flex:"1 1 140px"}}><label style={{fontSize:12,fontWeight:600}}>Date *</label>
            <input type="date" className="form-control form-control-sm" value={exSDate} onChange={e=>setExSDate(e.target.value)}/></div>
          <div style={{flex:"0 0 100px"}}><label style={{fontSize:12,fontWeight:600}}>Shift *</label>
            <div style={{marginTop:4}}><label style={{marginRight:10,fontSize:12}}><input type="radio" name="exSShift" value="0" checked={exSShift==="0"} onChange={e=>setExSShift(e.target.value)}/> AM</label><label style={{fontSize:12}}><input type="radio" name="exSShift" value="1" checked={exSShift==="1"} onChange={e=>setExSShift(e.target.value)}/> PM</label></div></div>
        </div>
        <div style={{marginBottom:14}}><label style={{fontSize:12,fontWeight:600}}>Import File *</label>
          <div style={{display:"flex",gap:10,alignItems:"center"}}><input type="file" accept=".csv,.xlsx,.xls" onChange={e=>setExSFile(e.target.files[0])} style={{fontSize:12}}/>
            <button className="btn btn-info btn-sm" onClick={handleExSPreview} disabled={exSLoading}>{exSLoading?<><i className="fas fa-spinner fa-spin" style={{marginRight:4}}/>Loading...</>:"Preview"}</button></div></div>
        {exSResult && <div style={{background:exSResult.success?"#d1e7dd":"#f8d7da",border:"1px solid "+(exSResult.success?"#a3cfbb":"#f1aeb5"),borderRadius:6,padding:"8px 14px",marginBottom:10,fontSize:13}}>{exSResult.message}</div>}
        {exSPreview.length>0 && <div style={{maxHeight:250,overflowY:"auto",border:"1px solid #dee2e6",borderRadius:6}}><table className="table table-sm table-bordered mb-0" style={{fontSize:11}}><thead style={{background:"#f8f9fa",position:"sticky",top:0}}><tr><th>#</th><th>Vendor</th><th>Milk</th><th>Qty</th><th>FAT</th><th>SNF</th><th>CLR</th><th>Status</th></tr></thead><tbody>{exSPreview.map((r,i)=><tr key={i} style={{background:r.error?"#fff3cd":"#fff"}}><td>{i+1}</td><td>{r.vendorNumber||r.serialNo||"-"}</td><td>{r.milkType==1?"Cow":r.milkType==2?"Buf":"Cmn"}</td><td>{r.qtyLtrs}</td><td>{r.fat||r.purchaseFat}</td><td>{r.snf||r.purchaseSnf}</td><td>{r.clr||r.purchaseClr}</td><td style={{color:r.error?"#dc3545":"#198754",fontSize:11}}>{r.error||"âœ“ Valid"}</td></tr>)}</tbody></table></div>}
      </ModalBody>
      <div style={{display:"flex",justifyContent:"flex-end",gap:8,padding:"10px 16px",borderTop:"1px solid #dee2e6"}}>
        <button className="btn btn-success btn-sm" onClick={handleExSSave} disabled={exSSaving||!exSPreview.length}>{exSSaving?"Saving...":"Save Changes"}</button>
        <button className="btn btn-danger btn-sm" onClick={()=>setExSOpen(false)}>Close</button></div>
    </Modal>

    {/* â•â• EXCEL IMPORT MULTI SHIFT MODAL â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â• */}
    <Modal isOpen={exMOpen} toggle={() => setExMOpen(false)} size="lg">
      <ModalHeader toggle={() => setExMOpen(false)}>Bulk Purchase Excel Import - Multiple Shift <span style={{color:"#dc3545",fontWeight:400,fontSize:13}}>[* required]</span></ModalHeader>
      <ModalBody>
        <div style={{display:"flex",gap:12,flexWrap:"wrap",marginBottom:14}}>
          {companies.length > 1 && (<div style={{flex:"1 1 170px"}}><label style={{fontSize:12,fontWeight:600}}>Company *</label><select className="form-control form-control-sm" onChange={e=>{setExMPlant("");setExMCC("");setExMPlants([]);setExMCCs([]);if(e.target.value)api.get("plants-by-company/"+e.target.value).then(r=>setExMPlants(arr(r))).catch(()=>{});else api.get("plants").then(r=>setExMPlants(arr(r))).catch(()=>{})}}><option value="">-- Select Company --</option>{companies.map(c=><option key={c.id} value={c.id}>{c.companyName||c.name}</option>)}</select></div>)}
          <div style={{flex:"1 1 170px"}}><label style={{fontSize:12,fontWeight:600}}>Plant *</label>
            <select className="form-control form-control-sm" value={exMPlant} onChange={e=>{setExMPlant(e.target.value);setExMCC("");setExMCCs([]);if(e.target.value)api.get("chillings-by-plant/"+e.target.value).then(r=>setExMCCs(arr(r))).catch(()=>{})}}><option value="">Select</option>{exMPlants.map(p=><option key={p.id} value={p.id}>{p.plantName||p.name}</option>)}</select></div>
          <div style={{flex:"1 1 200px"}}><label style={{fontSize:12,fontWeight:600}}>Chilling Center *</label>
            <select className="form-control form-control-sm" value={exMCC} onChange={e=>setExMCC(e.target.value)} disabled={!exMPlant}><option value="">Select</option>{exMCCs.map(c=><option key={c.id} value={c.id}>{c.chillingCenterName||c.name}</option>)}</select></div>
        </div>
        <div style={{marginBottom:14}}><label style={{fontSize:12,fontWeight:600}}>Import File *</label>
          <div style={{display:"flex",gap:10,alignItems:"center"}}><input type="file" accept=".csv,.xlsx,.xls" onChange={e=>setExMFile(e.target.files[0])} style={{fontSize:12}}/>
            <button className="btn btn-info btn-sm" onClick={handleExMPreview} disabled={exMLoading}>{exMLoading?<><i className="fas fa-spinner fa-spin" style={{marginRight:4}}/>Loading...</>:"Preview"}</button></div></div>
        {exMResult && <div style={{background:exMResult.success?"#d1e7dd":"#f8d7da",border:"1px solid "+(exMResult.success?"#a3cfbb":"#f1aeb5"),borderRadius:6,padding:"8px 14px",marginBottom:10,fontSize:13}}>{exMResult.message}</div>}
        {exMPreview.length>0 && <div style={{maxHeight:250,overflowY:"auto",border:"1px solid #dee2e6",borderRadius:6}}><table className="table table-sm table-bordered mb-0" style={{fontSize:11}}><thead style={{background:"#f8f9fa",position:"sticky",top:0}}><tr><th>#</th><th>Vendor</th><th>Date</th><th>Shift</th><th>Milk</th><th>Qty</th><th>FAT</th><th>SNF</th><th>Status</th></tr></thead><tbody>{exMPreview.map((r,i)=><tr key={i} style={{background:r.error?"#fff3cd":"#fff"}}><td>{i+1}</td><td>{r.vendorNumber||"-"}</td><td>{r.date||r.purchaseDate}</td><td>{r.shift==0?"AM":"PM"}</td><td>{r.milkType==1?"Cow":r.milkType==2?"Buf":"Cmn"}</td><td>{r.qtyLtrs}</td><td>{r.fat||r.purchaseFat}</td><td>{r.snf||r.purchaseSnf}</td><td style={{color:r.error?"#dc3545":"#198754",fontSize:11}}>{r.error||"âœ“"}</td></tr>)}</tbody></table></div>}
      </ModalBody>
      <div style={{display:"flex",justifyContent:"flex-end",gap:8,padding:"10px 16px",borderTop:"1px solid #dee2e6"}}>
        <button className="btn btn-success btn-sm" onClick={handleExMSave} disabled={exMSaving||!exMPreview.length}>{exMSaving?"Saving...":"Save Changes"}</button>
        <button className="btn btn-danger btn-sm" onClick={()=>setExMOpen(false)}>Close</button></div>
    </Modal>

    {/* â•â• FTP IMPORT MODAL â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â• */}
    <Modal isOpen={ftpIOpen} toggle={() => setFtpIOpen(false)}>
      <ModalHeader toggle={() => setFtpIOpen(false)}>Bulk Purchase FTP Import <span style={{color:"#dc3545",fontWeight:400,fontSize:13}}>[* required]</span></ModalHeader>
      <ModalBody>
        {companies.length > 1 && <div style={{marginBottom:12}}><label style={{fontSize:12,fontWeight:600}}>Company *</label><select className="form-control form-control-sm" onChange={e=>{setFtpIPlant("");setFtpICCs([]);if(e.target.value)api.get("plants-by-company/"+e.target.value).then(r=>setFtpIPlants(arr(r))).catch(()=>{})}}><option value="">Select</option>{companies.map(c=><option key={c.id} value={c.id}>{c.companyName||c.name}</option>)}</select></div>}
        <div style={{marginBottom:12}}><label style={{fontSize:12,fontWeight:600}}>Plant *</label>
          <select className="form-control form-control-sm" value={ftpIPlant} onChange={e=>morePlantChange(e.target.value,setFtpIPlant,setFtpICC,setFtpICCs)}><option value="">Select</option>{ftpIPlants.map(p=><option key={p.id} value={p.id}>{p.plantName||p.name}</option>)}</select></div>
        <div style={{marginBottom:12}}><label style={{fontSize:12,fontWeight:600}}>Chilling Center *</label>
          <select className="form-control form-control-sm" value={ftpICC} onChange={e=>setFtpICC(e.target.value)} disabled={!ftpIPlant}><option value="">Select</option>{ftpICCs.map(c=><option key={c.id} value={c.id}>{c.chillingCenterName||c.name}</option>)}</select></div>
        <div style={{marginBottom:12}}><label style={{fontSize:12,fontWeight:600}}>Date *</label>
          <input type="date" className="form-control form-control-sm" value={ftpIDate} onChange={e=>setFtpIDate(e.target.value)}/></div>
        <div style={{marginBottom:12}}><label style={{fontSize:12,fontWeight:600}}>Shift *</label>
          <div><label style={{marginRight:12,fontSize:12}}><input type="radio" name="ftpIShift" value="0" checked={ftpIShift==="0"} onChange={e=>setFtpIShift(e.target.value)}/> AM</label><label style={{fontSize:12}}><input type="radio" name="ftpIShift" value="1" checked={ftpIShift==="1"} onChange={e=>setFtpIShift(e.target.value)}/> PM</label></div></div>
        {ftpIResult && <div style={{background:ftpIResult.success?"#d1e7dd":"#f8d7da",border:"1px solid "+(ftpIResult.success?"#a3cfbb":"#f1aeb5"),borderRadius:6,padding:"8px 14px",fontSize:13}}>{ftpIResult.message}</div>}
      </ModalBody>
      <div style={{display:"flex",justifyContent:"flex-end",gap:8,padding:"10px 16px",borderTop:"1px solid #dee2e6"}}>
        <button className="btn btn-info btn-sm" onClick={handleFtpImport} disabled={ftpILoading}>{ftpILoading?<><i className="fas fa-spinner fa-spin" style={{marginRight:4}}/>Importing...</>:"Import"}</button>
        <button className="btn btn-danger btn-sm" onClick={()=>setFtpIOpen(false)}>Close</button></div>
    </Modal>

    {/* â•â• FTP EXPORT MODAL â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â• */}
    <Modal isOpen={ftpEOpen} toggle={() => setFtpEOpen(false)}>
      <ModalHeader toggle={() => setFtpEOpen(false)}>Bulk Purchase FTP Export <span style={{color:"#dc3545",fontWeight:400,fontSize:13}}>[* required]</span></ModalHeader>
      <ModalBody>
        {companies.length > 1 && <div style={{marginBottom:12}}><label style={{fontSize:12,fontWeight:600}}>Company *</label><select className="form-control form-control-sm" onChange={e=>{setFtpEPlant("");setFtpECCs([]);if(e.target.value)api.get("plants-by-company/"+e.target.value).then(r=>setFtpEPlants(arr(r))).catch(()=>{})}}><option value="">Select</option>{companies.map(c=><option key={c.id} value={c.id}>{c.companyName||c.name}</option>)}</select></div>}
        <div style={{marginBottom:12}}><label style={{fontSize:12,fontWeight:600}}>Plant *</label>
          <select className="form-control form-control-sm" value={ftpEPlant} onChange={e=>morePlantChange(e.target.value,setFtpEPlant,setFtpECC,setFtpECCs)}><option value="">Select</option>{ftpEPlants.map(p=><option key={p.id} value={p.id}>{p.plantName||p.name}</option>)}</select></div>
        <div style={{marginBottom:12}}><label style={{fontSize:12,fontWeight:600}}>Chilling Center *</label>
          <select className="form-control form-control-sm" value={ftpECC} onChange={e=>setFtpECC(e.target.value)} disabled={!ftpEPlant}><option value="">Select</option>{ftpECCs.map(c=><option key={c.id} value={c.id}>{c.chillingCenterName||c.name}</option>)}</select></div>
        <div style={{marginBottom:12}}><label style={{fontSize:12,fontWeight:600}}>Date *</label>
          <input type="date" className="form-control form-control-sm" value={ftpEDate} onChange={e=>setFtpEDate(e.target.value)}/></div>
        {ftpEResult && <div style={{background:ftpEResult.success?"#d1e7dd":"#f8d7da",border:"1px solid "+(ftpEResult.success?"#a3cfbb":"#f1aeb5"),borderRadius:6,padding:"8px 14px",fontSize:13}}>{ftpEResult.message}</div>}
      </ModalBody>
      <div style={{display:"flex",justifyContent:"flex-end",gap:8,padding:"10px 16px",borderTop:"1px solid #dee2e6"}}>
        <button className="btn btn-info btn-sm" onClick={handleFtpExport} disabled={ftpELoading}>{ftpELoading?<><i className="fas fa-spinner fa-spin" style={{marginRight:4}}/>Exporting...</>:"Export"}</button>
        <button className="btn btn-danger btn-sm" onClick={()=>setFtpEOpen(false)}>Close</button></div>
    </Modal>

    {/* â•â• CSV DOWNLOAD MODAL â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â• */}
    <Modal isOpen={csvOpen} toggle={() => setCsvOpen(false)}>
      <ModalHeader toggle={() => setCsvOpen(false)}>Download Purchases CSV <span style={{color:"#dc3545",fontWeight:400,fontSize:13}}>[* required]</span></ModalHeader>
      <ModalBody>
        <div style={{marginBottom:12}}>{companies.length > 1 && (<><label style={{fontSize:12,fontWeight:600}}>Company *</label><select className="form-control form-control-sm" onChange={e=>{setCsvPlant("");setCsvCC("");setCsvRoute("");setCsvPlants([]);setCsvCCs([]);setCsvRoutes([]);if(e.target.value)api.get("plants-by-company/"+e.target.value).then(r=>setCsvPlants(arr(r))).catch(()=>{});else api.get("plants").then(r=>setCsvPlants(arr(r))).catch(()=>{})}}><option value="">-- Select Company --</option>{companies.map(c=><option key={c.id} value={c.id}>{c.companyName||c.name}</option>)}</select></>)}</div>
        <div style={{marginBottom:12}}><label style={{fontSize:12,fontWeight:600}}>Plant *</label>
          <select className="form-control form-control-sm" value={csvPlant} onChange={e=>{setCsvPlant(e.target.value);setCsvCC("");setCsvRoute("");setCsvCCs([]);setCsvRoutes([]);if(e.target.value)api.get("chillings-by-plant/"+e.target.value).then(r=>setCsvCCs(arr(r))).catch(()=>{})}}><option value="">Select</option>{csvPlants.map(p=><option key={p.id} value={p.id}>{p.plantName||p.name}</option>)}</select></div>
        <div style={{marginBottom:12}}><label style={{fontSize:12,fontWeight:600}}>Chilling Center *</label>
          <select className="form-control form-control-sm" value={csvCC} onChange={e=>{setCsvCC(e.target.value);setCsvRoute("");setCsvRoutes([]);if(e.target.value)api.get("route-cc/"+e.target.value).then(r=>setCsvRoutes(arr(r))).catch(()=>{})}} disabled={!csvPlant}><option value="">Select</option>{csvCCs.map(c=><option key={c.id} value={c.id}>{c.chillingCenterName||c.name}</option>)}</select></div>
        <div style={{marginBottom:12}}><label style={{fontSize:12,fontWeight:600}}>Route</label>
          <select className="form-control form-control-sm" value={csvRoute} onChange={e=>setCsvRoute(e.target.value)} disabled={!csvCC}><option value="">All Routes</option>{csvRoutes.map(r=><option key={r.id} value={r.id}>{r.routeName||r.name}</option>)}</select></div>
        <div style={{display:"flex",gap:12,marginBottom:12}}>
          <div style={{flex:1}}><label style={{fontSize:12,fontWeight:600}}>Date *</label><input type="date" className="form-control form-control-sm" value={csvDate} onChange={e=>setCsvDate(e.target.value)}/></div>
          <div style={{flex:1}}><label style={{fontSize:12,fontWeight:600}}>Shift</label><select className="form-control form-control-sm" value={csvShift} onChange={e=>setCsvShift(e.target.value)}><option value="">Both</option><option value="0">AM</option><option value="1">PM</option></select></div>
        </div>
      </ModalBody>
      <div style={{display:"flex",justifyContent:"flex-end",gap:8,padding:"10px 16px",borderTop:"1px solid #dee2e6"}}>
        <button className="btn btn-primary btn-sm" onClick={handleCsvDownload} disabled={csvLoading}>{csvLoading?<><i className="fas fa-spinner fa-spin" style={{marginRight:4}}/>Downloading...</>:<><i className="fas fa-download" style={{marginRight:4}}/>Download</>}</button>
        <button className="btn btn-danger btn-sm" onClick={()=>setCsvOpen(false)}>Close</button></div>
    </Modal>

    {/* â•â• ADDITIONAL INCENTIVE UPDATE MODAL â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â• */}
    <Modal isOpen={incOpen} toggle={() => setIncOpen(false)}>
      <ModalHeader toggle={() => setIncOpen(false)}>Additional Incentive Update <span style={{color:"#dc3545",fontWeight:400,fontSize:13}}>[* required]</span></ModalHeader>
      <ModalBody>
        <div style={{marginBottom:12}}>{companies.length > 1 && (<><label style={{fontSize:12,fontWeight:600}}>Company *</label><select className="form-control form-control-sm" onChange={e=>{setIncPlant("");setIncCC("");setIncPlants([]);setIncCCs([]);if(e.target.value)api.get("plants-by-company/"+e.target.value).then(r=>setIncPlants(arr(r))).catch(()=>{});else api.get("plants").then(r=>setIncPlants(arr(r))).catch(()=>{})}}><option value="">-- Select Company --</option>{companies.map(c=><option key={c.id} value={c.id}>{c.companyName||c.name}</option>)}</select></>)}</div>
        <div style={{marginBottom:12}}><label style={{fontSize:12,fontWeight:600}}>Plant *</label>
          <select className="form-control form-control-sm" value={incPlant} onChange={e=>{setIncPlant(e.target.value);setIncCC("");setIncCCs([]);if(e.target.value)api.get("chillings-by-plant/"+e.target.value).then(r=>setIncCCs(arr(r))).catch(()=>{})}}><option value="">Select</option>{incPlants.map(p=><option key={p.id} value={p.id}>{p.plantName||p.name}</option>)}</select></div>
        <div style={{marginBottom:12}}><label style={{fontSize:12,fontWeight:600}}>Chilling Center *</label>
          <select className="form-control form-control-sm" value={incCC} onChange={e=>setIncCC(e.target.value)} disabled={!incPlant}><option value="">Select</option>{incCCs.map(c=><option key={c.id} value={c.id}>{c.chillingCenterName||c.name}</option>)}</select></div>
        <div style={{display:"flex",gap:12,marginBottom:12}}>
          <div style={{flex:1}}><label style={{fontSize:12,fontWeight:600}}>Date *</label><input type="date" className="form-control form-control-sm" value={incDate} onChange={e=>setIncDate(e.target.value)}/></div>
          <div style={{flex:1}}><label style={{fontSize:12,fontWeight:600}}>Shift</label><select className="form-control form-control-sm" value={incShift} onChange={e=>setIncShift(e.target.value)}><option value="">Both</option><option value="0">AM</option><option value="1">PM</option></select></div>
        </div>
        <div style={{marginBottom:12}}><label style={{fontSize:12,fontWeight:600}}>Incentive Amount (per Ltr) *</label>
          <input type="number" step="0.01" min="0" className="form-control form-control-sm" value={incAmount} onChange={e=>setIncAmount(e.target.value)} placeholder="e.g. 0.50"/></div>
        {incResult && <div style={{background:incResult.success?"#d1e7dd":"#f8d7da",border:"1px solid "+(incResult.success?"#a3cfbb":"#f1aeb5"),borderRadius:6,padding:"8px 14px",fontSize:13}}>{incResult.message}</div>}
      </ModalBody>
      <div style={{display:"flex",justifyContent:"flex-end",gap:8,padding:"10px 16px",borderTop:"1px solid #dee2e6"}}>
        <button className="btn btn-success btn-sm" onClick={handleIncUpdate} disabled={incLoading}>{incLoading?<><i className="fas fa-spinner fa-spin" style={{marginRight:4}}/>Updating...</>:"Update Incentive"}</button>
        <button className="btn btn-danger btn-sm" onClick={()=>setIncOpen(false)}>Close</button></div>
    </Modal>


    {/* == PROCUREMENT COMPARISON SUMMARY MODAL ========================= */}
    <Modal isOpen={cmpOpen} toggle={() => setCmpOpen(false)} size="xl">
      <ModalHeader toggle={() => setCmpOpen(false)}>Procurement Comparison Summary Print <span style={{color:"#dc3545",fontWeight:400,fontSize:13}}>[* required]</span></ModalHeader>
      <ModalBody style={{padding:"18px 22px"}}>
        <div style={{display:"flex",gap:14,flexWrap:"wrap",marginBottom:14}}>
          {companies.length > 1 && (
            <div style={{flex:"1 1 200px"}}><label style={{fontSize:12,fontWeight:600}}>Company *</label>
              <select className="form-control form-control-sm" onChange={e=>{setCmpPlant("");setCmpCC("");setCmpRoute("");setCmpCenter("");setCmpPlants([]);setCmpCCs([]);setCmpRoutes([]);setCmpCenters([]);if(e.target.value)api.get("plants-by-company/"+e.target.value).then(r=>setCmpPlants(arr(r))).catch(()=>{});else api.get("plants").then(r=>setCmpPlants(arr(r))).catch(()=>{})}}>
                <option value="">-- Select Company --</option>
                {companies.map(c => <option key={c.id} value={c.id}>{c.companyName||c.name}</option>)}
              </select></div>
          )}
          <div style={{flex:"1 1 200px"}}><label style={{fontSize:12,fontWeight:600}}>Plant *</label>
            <select className="form-control form-control-sm" value={cmpPlant} onChange={e => onCmpPlant(e.target.value)}>
              <option value="">Select</option>
              {cmpPlants.map(p => <option key={p.id} value={p.id}>{p.plantName||p.name}</option>)}
            </select></div>
          <div style={{flex:"1 1 200px"}}><label style={{fontSize:12,fontWeight:600}}>Chilling Center *</label>
            <select className="form-control form-control-sm" value={cmpCC} disabled={!cmpPlant} onChange={e => onCmpCC(e.target.value)}>
              <option value="">Select</option>
              {cmpCCs.map(c => <option key={c.id} value={c.id}>{c.chillingCenterName||c.name}</option>)}
            </select></div>
          <div style={{flex:"1 1 160px"}}><label style={{fontSize:12,fontWeight:600}}>Route</label>
            <select className="form-control form-control-sm" value={cmpRoute} disabled={!cmpCC} onChange={e => onCmpRoute(e.target.value)}>
              <option value="">All</option>
              {cmpRoutes.map(r => <option key={r.id} value={r.id}>{r.routeName||r.name}</option>)}
            </select></div>
          <div style={{flex:"1 1 160px"}}><label style={{fontSize:12,fontWeight:600}}>Center</label>
            <select className="form-control form-control-sm" value={cmpCenter} disabled={!cmpRoute} onChange={e => setCmpCenter(e.target.value)}>
              <option value="">All</option>
              {cmpCenters.map(c => <option key={c.id} value={c.id}>{c.centerName||c.name}</option>)}
            </select></div>
        </div>
        <div style={{display:"flex",gap:14,flexWrap:"wrap",marginBottom:14}}>
          <div style={{flex:"1 1 160px"}}><label style={{fontSize:12,fontWeight:600}}>Period From *</label>
            <input type="date" className="form-control form-control-sm" value={cmpFrom} onChange={e => setCmpFrom(e.target.value)}/></div>
          <div style={{flex:"1 1 160px"}}><label style={{fontSize:12,fontWeight:600}}>Period To *</label>
            <input type="date" className="form-control form-control-sm" value={cmpTo} onChange={e => setCmpTo(e.target.value)}/></div>
          <div style={{flex:"1 1 240px"}}><label style={{fontSize:12,fontWeight:600}}>Display Entries *</label>
            <div style={{display:"flex",gap:12,marginTop:6}}>
              <label style={{fontSize:12}}><input type="radio" name="cmpDisp" checked={cmpDisplay==="all"} onChange={()=>setCmpDisplay("all")} style={{marginRight:3}}/>All</label>
              <label style={{fontSize:12}}><input type="radio" name="cmpDisp" checked={cmpDisplay==="shortage"} onChange={()=>setCmpDisplay("shortage")} style={{marginRight:3}}/>Shortage Only</label>
              <label style={{fontSize:12}}><input type="radio" name="cmpDisp" checked={cmpDisplay==="excess"} onChange={()=>setCmpDisplay("excess")} style={{marginRight:3}}/>Excess Only</label>
            </div></div>
          <div style={{flex:"1 1 300px"}}><label style={{fontSize:12,fontWeight:600}}>Comparison Based On *</label>
            <div style={{display:"flex",gap:10,marginTop:6,flexWrap:"wrap"}}>
              {[["qty_only","Qty Only"],["ts_only","TS Only"],["qty_ts","Qty & TS"],["qty_or_ts","Qty Or TS"],["amount","Amount"]].map(([v,l])=>(
                <label key={v} style={{fontSize:12}}><input type="radio" name="cmpBasis" checked={cmpBasis===v} onChange={()=>setCmpBasis(v)} style={{marginRight:3}}/>{l}</label>
              ))}
            </div></div>
        </div>
        <div style={{display:"flex",gap:14,flexWrap:"wrap",marginBottom:14,alignItems:"flex-end"}}>
          <div style={{flex:"0 0 220px",position:"relative"}}><label style={{fontSize:12,fontWeight:600}}>Display Parameters</label>
            <div className="form-control form-control-sm" style={{cursor:"pointer",fontSize:12,minHeight:31}} onClick={()=>setCmpParamOpen(!cmpParamOpen)}>
              {cmpParams.length === 0 ? <span style={{color:"#999"}}>Nothing selected</span> : cmpParams.join(", ")}
            </div>
            {cmpParamOpen && (
              <div style={{position:"absolute",top:"100%",left:0,right:0,background:"#fff",border:"1px solid #dee2e6",borderRadius:4,zIndex:10,boxShadow:"0 2px 8px rgba(0,0,0,.15)",padding:"6px 0"}}>
                <div style={{display:"flex",justifyContent:"space-between",padding:"2px 10px",borderBottom:"1px solid #eee",marginBottom:4}}>
                  <span style={{cursor:"pointer",color:"#0d6efd",fontSize:11}} onClick={()=>setCmpParams([...cmpParamOptions])}>Select All</span>
                  <span style={{cursor:"pointer",color:"#0d6efd",fontSize:11}} onClick={()=>setCmpParams([])}>Deselect All</span>
                </div>
                {cmpParamOptions.map(p => (
                  <label key={p} style={{display:"block",padding:"3px 10px",fontSize:12,cursor:"pointer"}}>
                    <input type="checkbox" checked={cmpParams.includes(p)} onChange={()=>toggleCmpParam(p)} style={{marginRight:6}}/>{p}
                  </label>
                ))}
              </div>
            )}
          </div>
          <div>
            <button className="btn btn-primary btn-sm" onClick={handleCmpPrint} disabled={cmpLoading}>
              {cmpLoading ? <><i className="fas fa-spinner fa-spin" style={{marginRight:4}}/>Loading...</> : <><i className="fas fa-print" style={{marginRight:4}}/>Print Summary</>}
            </button>
          </div>
        </div>
        {cmpResult && (
          <div style={{background:cmpResult.success?"#d1e7dd":"#f8d7da",border:"1px solid "+(cmpResult.success?"#a3cfbb":"#f1aeb5"),borderRadius:6,padding:"8px 14px",fontSize:13,marginBottom:10}}>
            {cmpResult.message}
          </div>
        )}
      </ModalBody>
      <div style={{display:"flex",justifyContent:"flex-end",padding:"10px 16px",borderTop:"1px solid #dee2e6"}}>
        <button className="btn btn-danger btn-sm" onClick={() => setCmpOpen(false)}>Close</button>
      </div>
    </Modal>
    {/* == PURCHASE COLOR MARKING DETAILS MODAL ======================== */}
    <Modal isOpen={colorOpen} toggle={() => setColorOpen(false)}>
      <ModalHeader toggle={() => setColorOpen(false)} style={{background:"#ffc107",color:"#000"}}><strong>Purchase Color Marking Details</strong></ModalHeader>
      <ModalBody style={{padding:"20px 24px"}}>
        {[
          { color: "#333333", label: "Captured from Analyzer/Scale in App" },
          { color: "#5b21b6", label: "Manual Entry in App" },
          { color: "#78350f", label: "Entry Modified by capturing again from Analyzer/Scale in App" },
          { color: "#dc2626", label: "Entry Modified manually from App" },
          { color: "#b45309", label: "Added from Server" },
          { color: "#7c3aed", label: "Updated from Server" },
          { color: "#047857", label: "Imported from Server" },
        ].map((item, i) => (
          <div key={i} style={{display:"flex",alignItems:"center",gap:12,marginBottom:12}}>
            <span style={{display:"inline-block",width:22,height:22,background:item.color,borderRadius:3,flexShrink:0}}/>
            <span style={{fontSize:13}}>{item.label}</span>
          </div>
        ))}
      </ModalBody>
      <div style={{display:"flex",justifyContent:"flex-end",padding:"10px 16px",borderTop:"1px solid #dee2e6"}}>
        <button className="btn btn-secondary btn-sm" onClick={()=>setColorOpen(false)}>Close</button></div>
    </Modal>

    </>
  )
}

export default CCPurchases
